import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import cx from 'classnames';
import tw from 'twin.macro';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import { Helmet } from '@dr.pogodin/react-helmet';
import queryString from 'query-string';
import config from 'temp/config';
import { useUiValue } from 'stores/uiContext';
import { useCountryValue } from 'stores/country';
import useFavorites from 'utils/hooks/useFavorites';
import { searchProductTypes } from 'utils/enums';
import breakpoints from 'utils/breakpoints';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import useMetroSearchSelectedMetro from 'utils/hooks/useMetroSearchSelectedMetro';
import useMouseflowTracking from 'utils/hooks/useMouseflowTracking';
import withRouter from 'utils/withRouter';

import MetroSearchPromoBanner from '../MetroSearchPromoBanner';
import MapMarkerIcon from 'components/icons/MapMarker';
import { ToggleMap } from 'components/components/atoms';
import {
  WaitingScreen,
  MapSearchCardMobile,
} from 'components/components/molecules';
import {
  SearchResult,
  SearchMap,
  PrimaryFilter,
  SecondaryFilter,
  MobileFilters,
  MoreFiltersModal,
} from 'components/components/organisms';

const Content = styled.div`
  ${tw`flex`}
  ${({ promoBannerActive, measure }) =>
    promoBannerActive
      ? `height: calc(100vh - ${measure + 190}px);`
      : 'height: calc(100vh - 12rem);'}
`;
// 5.125rem
const ToogleMapMobile = styled.div`
  ${({ isMapOpen }) => (isMapOpen ? 'z-index: 50;' : 'z-index: 30;')}
`;

const IconContainer = styled.div`
  width: 1.625rem;
  height: 1.625rem;
`;

const ListIconBar = styled.span`
  height: 0.125rem;
  width: 10px;
`;

const SearchResultContainer = styled.div`
  ${tw`h-full w-full flex flex-col`}
  scroll-behavior: smooth;

  @media ${breakpoints.md} {
    ${({ showMap }) => (showMap ? tw`w-7/12` : tw`w-full`)}
  }
`;
const SearchSection = styled.section`
  ${({ promoBannerActive, measure }) =>
    promoBannerActive ? `margin-top: ${measure}px;` : 'margin-top: 0px;'}
`;

/* ${({ isMobile, showMap, promoBannerActive, measure }) =>
    showMap &&
    isMobile &&
    promoBannerActive &&
    "margin-top: 16rem; height: calc(100% - 12rem - ${measure + 190}px);"}
  ${({ isMobile, showMap, promoBannerActive }) =>
    showMap &&
    isMobile &&
    !promoBannerActive &&
    "margin-top: 12rem; height: calc(100% - 12rem);"}
    height: calc(100vh - 12rem);
    */
const SearchMapContainer = styled(animated.div)`
  ${({ hidden }) => hidden && 'display: none !important;'}

  ${tw`h-full md:block md:right-0`}
  ${({ showMap }) =>
    showMap && tw`flex-col justify-end fixed top-0 w-full z-10`}

  ${({ mounted }) => !mounted && 'display: none !important;'}

  ${({ isMobile, promoBannerActive, measure }) =>
    isMobile && promoBannerActive ? `margin-top: ${measure + 190}px;` : ''}

  ${({ promoBannerActive, measure }) =>
    promoBannerActive ? `height: calc(100vh - ${measure + 190}px);` : ''}
    
  @media ${breakpoints.md} {
    ${tw`flex absolute w-5/12`}
    z-index: 8;
  }
`;

const MapWrapper = styled.div`
  @media ${breakpoints.md} {
    height: calc(100% - 5rem);
  }
  @media ${breakpoints.xl} {
    height: 100%;
  }
`;
const SearchCardsContainer = styled.div`
  @media ${breakpoints.md} {
    height: calc(100% - 5rem);
  }
  @media ${breakpoints.xl} {
    height: 100%;
  }
`;

const mapProducts = (communities, products, productsKey) =>
  products.reduce((accum, product) => {
    if (product.idCommunity) {
      const communityKey = `${product.idCommunity}`;
      if (accum[communityKey]) {
        (accum[communityKey][productsKey] =
          accum[communityKey][productsKey] || []).push(product);
      }
    }
    return accum;
  }, communities);

const applyFilters = (
  array,
  priceFilter,
  bedroomsFilter,
  sizeFilter,
  homeTypeFilter,
  selectedCommunity,
  citiesFilter,
  amenitiesFilter,
  bathroomsFilter,
  garagesFilter,
  lotSizeFilter,
  productLineFilter,
  storiesFilter,
  communityStylesFilter,
  hasDen,
  selectedMetro,
  isRVSelected,
) =>
  !Array.isArray(array)
    ? []
    : array.filter((el) => {
        let community = true;
        let price = true;
        let bedrooms = true;
        let size = true;
        let homeType = true;
        let cities = true;
        /* const cities =
        citiesFilter && citiesFilter.length
          ? citiesFilter.includes(el.city)
          : true;*/
        let amenities = true;
        let bathrooms = true;
        let garages = true;
        let lotSize = true;
        let productLine = true;
        let stories = true;
        let communityStyle = true;
        let rvSelected = true;

        for (let sC = 0; sC < selectedCommunity.length; sC++) {
          if (
            selectedCommunity.length > 0 &&
            selectedCommunity[sC].title !== 'All'
          ) {
            if (selectedCommunity[sC].type !== 'MPC') {
              const elementCommunity = el.idCommunity;
              community = elementCommunity === selectedCommunity[sC].id;
            } else {
              community = false;
            }

            if (community) break;
          }
        }

        if (priceFilter) {
          const elementPrice = parseFloat(
            eval(el.price.price.replace(/\D/g, '')),
          );
          price =
            (priceFilter.min ? elementPrice >= priceFilter.min : true) &&
            (priceFilter.max ? elementPrice <= priceFilter.max : true);
        }
        if (sizeFilter) {
          const sizeAttr = el.attributes.find((a) => a.icon === 'ruler');
          if (sizeAttr) {
            const minSize = parseInt(sizeAttr.label.split('-')[0]);
            const maxSize = parseInt(sizeAttr.label.split('-')[1]) || minSize;
            size = !(minSize > sizeFilter.max || maxSize < sizeFilter.min);
          }
        }
        if (
          homeTypeFilter &&
          homeTypeFilter.length &&
          homeTypeFilter[0] !== 'All'
        ) {
          homeType = (el.homeType || '')
            .split(',')
            .some((item) => homeTypeFilter.includes(item));
        }
        /* if (homeTypeFilter && homeTypeFilter !== "All") {
        const homeTypes = el.homeType
          ? el.homeType.replace(/\s/g, "").split(",")
          : [];

        if (!homeTypes.includes(homeTypeFilter.replace(/\s/g, ""))) {
          homeType = false;
        }
      }*/
        if (citiesFilter && citiesFilter.length) {
          cities = citiesFilter.includes(el.city.trim() || '');
        }
        if (amenitiesFilter && amenitiesFilter.length) {
          amenities = (el.amenities || '')
            .split(',')
            .some((item) => amenitiesFilter.includes(item.trim()));
        }
        if (lotSizeFilter && lotSizeFilter.length) {
          lotSize = (el.lotSizes || '')
            .split(',')
            .some((item) => lotSizeFilter.includes(item.trim()));
        }
        if (productLineFilter && productLineFilter.length) {
          productLine = (el.productLines || '')
            .split(',')
            .some((item) => productLineFilter.includes(item.trim()));
        }
        if (communityStylesFilter && communityStylesFilter.length) {
          communityStyle = (el.communityStyles || '')
            .split(',')
            .some((item) => communityStylesFilter.includes(item.trim()));
        }
        if (
          bedroomsFilter &&
          bedroomsFilter.length > 0 &&
          ((!hasDen && bedroomsFilter.length !== 4) ||
            (hasDen && bedroomsFilter.length !== 7))
        ) {
          const bedAttr = el.attributes.find((a) => a.icon === 'bed');
          if (bedAttr) {
            const minBeds = parseInt(bedAttr.label.split('-')[0]);
            const maxBeds = parseInt(bedAttr.label.split('-')[1]) || minBeds;
            const bedwDen = el.isCondo && el.type === 'Plan' && el.den;
            for (let i = 0; i < bedroomsFilter.length; i++) {
              const filter = bedroomsFilter[i];
              let filterWithDen = false;
              if (filter - Math.trunc(filter) === 0.5) {
                filterWithDen = true;
              }
              if (bedwDen && filterWithDen) {
                if (filter < 4) {
                  bedrooms = filter >= minBeds + 0.5 && filter <= maxBeds + 0.5;
                } else {
                  bedrooms = filter <= maxBeds + 0.5;
                }
              } else {
                if (!bedwDen && filterWithDen) {
                  bedrooms = false;
                } else {
                  if (filter < 4) {
                    bedrooms = filter >= minBeds && filter <= maxBeds;
                  } else {
                    bedrooms = filter <= maxBeds;
                  }
                }
              }
              if (bedrooms) break;
            }
          }
        }
        if (
          bathroomsFilter &&
          bathroomsFilter.length > 0 &&
          bathroomsFilter.length !== 4
        ) {
          const bathAttr = el.attributes.find((a) => a.icon === 'bath');
          if (bathAttr) {
            const minBaths = parseInt(bathAttr.label.split('-')[0]);
            const maxBaths = parseInt(bathAttr.label.split('-')[1]) || minBaths;
            for (let i = 0; i < bathroomsFilter.length; i++) {
              const filter = bathroomsFilter[i];
              if (filter < 4) {
                bathrooms = filter >= minBaths && filter <= maxBaths;
              } else {
                bathrooms = filter <= maxBaths;
              }
              if (bathrooms) break;
            }
          }
        }
        if (garagesFilter && garagesFilter.length > 0) {
          const carAttr = el.attributes.find((a) => a.icon === 'car');
          if (carAttr) {
            const minCar = parseInt(carAttr.label.split('-')[0]);
            const maxCar = parseInt(carAttr.label.split('-')[1]) || minCar;
            for (let i = 0; i < garagesFilter.length; i++) {
              const filter = garagesFilter[i];
              if (filter < 3) {
                garages = filter >= minCar && filter <= maxCar;
              } else {
                garages = filter <= maxCar;
              }
              if (garages) break;
            }
          }
        }
        if (storiesFilter && storiesFilter.length > 0) {
          const storiesAttr = el.attributes.find((a) => a.icon === 'stories');
          if (storiesAttr) {
            const minStories = parseInt(storiesAttr.label.split('-')[0]);
            const maxStories =
              parseInt(storiesAttr.label.split('-')[1]) || minStories;
            for (let i = 0; i < storiesFilter.length; i++) {
              const filter = storiesFilter[i];
              if (filter < 3) {
                stories = filter >= minStories && filter <= maxStories;
              } else {
                stories = filter <= maxStories;
              }
              if (stories) break;
            }
          }
        }
        // console.log({isRVSelected})
        if (isRVSelected) {
          rvSelected = el.rvGarage;
        }
        return (
          community &&
          price &&
          bedrooms &&
          size &&
          homeType &&
          cities &&
          amenities &&
          bathrooms &&
          garages &&
          lotSize &&
          productLine &&
          stories &&
          communityStyle &&
          rvSelected
        );
      });

const filterCards = (populatedCommunities, productType, ...filters) =>
  Object.entries(populatedCommunities).reduce((accum, [key, community]) => {
    // console.log({ filters });
    const showMap = filters[16];
    const isHiddenMap = filters[17];
    const isState =
      filters[14] &&
      filters[14][0] &&
      filters[14][0].name.toLowerCase() === filters[14][0].state.toLowerCase();
    const selectedMetroList = filters[14];
    const selectedMetro =
      selectedMetroList &&
      selectedMetroList[0] &&
      selectedMetroList[0].name.toLowerCase();
    if (!showMap) {
      if (
        !isState &&
        isHiddenMap &&
        selectedMetroList &&
        selectedMetroList.length > 1
      ) {
        const selectedMetroNames = selectedMetroList.map((metro) =>
          metro.name.toLowerCase(),
        );
        if (!selectedMetroNames.includes(community.metro.toLowerCase())) {
          return accum;
        }
      } else if (!isState && community.metro.toLowerCase() !== selectedMetro) {
        return accum;
      }
    }

    if (!['plan', 'qmi'].includes(productType)) {
      return accum;
    }

    const productsKey = productType === 'plan' ? 'plans' : 'qmi';

    let products = community[productsKey];
    // console.log({ filters });
    const filteredProducts = applyFilters(products, ...filters);

    return [...accum, ...filteredProducts];
  }, []);

const filterByVisibilityInMap = (
  items,
  visibleIds,
  showMap,
  isMobile,
  useMapViewportFilter,
) => {
  // console.log("filterByVisibilityInMap", { items, visibleIds, showMap });
  if (!items) return [];
  if (isMobile) {
    if (!useMapViewportFilter) {
      return items;
    }

    return items.filter(
      (item) =>
        visibleIds.includes(item.id) ||
        visibleIds.includes(item.idCommunity) ||
        visibleIds.includes(item.idMpc),
    );
  }
  if (!visibleIds) return items;
  if ((visibleIds && visibleIds.length < 1) || !showMap) return items;
  return items.filter(
    (item) =>
      visibleIds.includes(item.idCommunity) || visibleIds.includes(item.idMpc),
  );
};

const getSelectedMetroAreaMapPins = (items, selectedMetro) => {
  if (!(selectedMetro && selectedMetro.length > 0)) {
    return items.map((item) => item.id);
  }

  let itemIds = [];
  for (let i = 0; i < selectedMetro.length; i++) {
    const metro = selectedMetro[i];
    const isState = metro.name.toLowerCase() === metro.state.toLowerCase();

    if (isState) {
      return items
        .filter((item) => item.state.toLowerCase() === metro.name.toLowerCase())
        .map((item) => item.id);
    }

    const metroIds = items
      .filter((item) => item.metro.toLowerCase() === metro.name.toLowerCase())
      .map((item) => item.id);
    itemIds = itemIds.concat(metroIds);
  }

  return itemIds;
};

const getSelectedMetroFromQuery = (data, country, metroList) => {
  // latLng
  const metros = getFieldValue(data, 'metrosFilter');
  const countryMetros = metros && metros.filter((i) => i.country === country);
  const metroParam = metroList.split(',');
  // console.log({ metroParam, country });
  if (metroParam && metroParam.length > 0 && metroParam[0]) {
    let metros = [];
    for (let i = 0; i < metroParam.length; i++) {
      const metroCity = countryMetros.find(
        (m) => m.name.toLowerCase() === metroParam[i].toLowerCase(),
      );
      if (metroCity) metros.push(metroCity);
    }
    /*
    const metroCity = countryMetros.find(
      (m) => m.name.toLowerCase() === metroParam.toLowerCase()
    );*/
    // console.log({ metroParam, metros });
    if (metros && metros.length > 0) {
      return metros; // metroCity
    } else {
      const cities = countryMetros.filter(
        (m) => m.state.toLowerCase() === metroParam[0].toLowerCase(),
      );
      if (cities && cities.length > 0) {
        return [
          {
            cities,
            country: cities[0].country,
            name: cities[0].state,
            state: cities[0].state,
          },
        ];
      } else {
        return [
          {
            cities,
            country: countryMetros[0].country,
            name: countryMetros[0].state,
            state: countryMetros[0].state,
          },
        ];
      }
    }
  } else {
    // nearest country
    /* const lat = parseFloat(latLng.lat);
    const lng = parseFloat(latLng.lng);

    const marketsWithDistances = metros.map((m) => ({
      ...m,
      distance: getDistanceMap(
        lat,
        lng,
        parseFloat(m.latitude),
        parseFloat(m.longitude)
      ),
    }));

    const marketsSortedByDistance = marketsWithDistances
      .filter((el) => el.distance)
      .sort((m1, m2) => m1.distance - m2.distance);

    const closestMarket = marketsSortedByDistance[0];
    if (closestMarket) {
      return closestMarket;
    }
    //console.log(latLng, closestMarket, metros);*/

    return [countryMetros[0]];
  }
};

const getMoreFiltersNumber = (
  citiesFilter,
  amenitiesFilter,
  garagesFilter,
  lotSizeFilter,
  productLineFilter,
  storiesFilter,
  communityStylesFilter,
) => {
  let res = 0;

  if (citiesFilter) res += citiesFilter.length;
  if (amenitiesFilter) res += amenitiesFilter.length;
  if (communityStylesFilter) res += communityStylesFilter.length;
  if (garagesFilter) res += garagesFilter.length;
  if (lotSizeFilter) res += lotSizeFilter.length;
  if (productLineFilter) res += productLineFilter.length;
  if (storiesFilter) res += storiesFilter.length;

  return res;
};

const filterLatLng = (c) => c.latitudeCommunity && c.longitudeCommunity;

const getProductTypeTitle = (fields, productType) => {
  if (productType === searchProductTypes.COMMUNITY) {
    return getFieldValue(fields, 'headlineCommunity');
  }
  if (productType === searchProductTypes.PLAN)
    return getFieldValue(fields, 'headlinePlan');
  if (productType === searchProductTypes.QMI)
    return getFieldValue(fields, 'headlineQMI');
};

const filterNoLatLngCards = (fields) => {
  const mpcCards = getFieldValue(fields, 'mpcCards') || [];
  const communityCards = getFieldValue(fields, 'communityCards') || [];
  const planCards = getFieldValue(fields, 'planCards') || [];
  const qmiCards = getFieldValue(fields, 'qmiCards') || [];
  const filteredMpcCards = mpcCards.filter(filterLatLng);
  const filteredCommunityCards = communityCards.filter(filterLatLng);
  const filteredPlanCards = planCards.filter(filterLatLng);
  const filteredQmiCards = qmiCards.filter(filterLatLng);

  return {
    ...fields,
    mpcCards: {
      value: filteredMpcCards,
    },
    communityCards: {
      value: filteredCommunityCards,
    },
    planCards: {
      value: filteredPlanCards,
    },
    qmiCards: {
      value: filteredQmiCards,
    },
    nMPC: {
      value: filteredMpcCards.length,
    },
    nCommunity: {
      value: filteredCommunityCards.length,
    },
    nPlan: {
      value: filteredPlanCards.length,
    },
    nQMI: {
      value: filteredQmiCards.length,
    },
  };
};

const SELECTED_COMMUNITY_FILTER_KEY = 4;

const hasAttribute = (filters, value) => {
  if (value) {
    const values = value.split(',');
    const resultTrim = values.map((e) => e.trim());
    if (filters) {
      for (let i = 0; i < filters.length; i++) {
        if (resultTrim && resultTrim.includes(filters[i].trim())) {
          return true;
        }
      }
    }
  }
  return false;
};

const filterCommunities = (allCommunities, ...filters) => {
  // console.log(allCommunities, filters);
  const citiesFilter = filters[5];
  const amenitiesFilter = filters[6];
  const priceFilter = filters[0];
  const communityStyleFilter = filters[12];
  const homeTypeFilter = filters[3];
  const lotSizeFilter = filters[9];
  const productLineFilter = filters[10];
  const hasDen = filters[13];
  const hasBedroomsFilter =
    filters[1] &&
    filters[1].length > 0 &&
    ((hasDen && filters[1].length !== 7) ||
      (!hasDen && filters[1].length !== 4));
  const hasBathroomsFilter =
    filters[7] && filters[7].length > 0 && filters[7].length !== 4;
  const hasGarageFilter = filters[8] && filters[8].length > 0;
  const hasStoriesFilter = filters[11] && filters[11].length > 0;

  const selectedMetro = filters[14]; // && filters[14][0] && filters[14][0].name.toLowerCase();
  const showMap = filters[16];
  const isHiddenMap = filters[17];
  const isState =
    filters[14] &&
    filters[14][0] &&
    filters[14][0].name.toLowerCase() === filters[14][0].state.toLowerCase();
  let communities = [];

  if (
    !showMap /* ||
    hasBedroomsFilter ||
    hasBathroomsFilter ||
    hasGarageFilter ||
    hasStoriesFilter ||
    (citiesFilter && citiesFilter.length > 0) ||
    (amenitiesFilter && amenitiesFilter.length > 0) ||
    (communityStyleFilter && communityStyleFilter.length > 0) ||
    (homeTypeFilter &&
      homeTypeFilter.length > 0 &&
      homeTypeFilter[0] !== "All") ||
    (lotSizeFilter && lotSizeFilter.length > 0) ||
    (productLineFilter && productLineFilter.length > 0) ||
    (priceFilter && (priceFilter.min > 0 || priceFilter.max > 0))*/
  ) {
    if (isState) communities = allCommunities.map((e) => e);
    else {
      // console.log({ selectedMetro });
      if (selectedMetro && selectedMetro.length > 0) {
        if (selectedMetro.length > 1) {
          if (isHiddenMap) {
            const selectedMetroNames = selectedMetro.map((metro) =>
              metro.name.toLowerCase(),
            );
            communities = allCommunities.filter((e) =>
              selectedMetroNames.includes(e.metro.toLowerCase()),
            );
          } else {
            communities = allCommunities.map((e) => e);
          }
        } else {
          communities = allCommunities.filter(
            (e) =>
              e.metro.toLowerCase() === selectedMetro[0].name.toLowerCase(),
          );
        }
      }
    }
  } else {
    communities = allCommunities.map((e) => e);
  }

  const filteredPlansAndQMITemp = communities.reduce((accum, c) => {
    const { qmi, plans } = c;
    const communityHomeTypeList = c.homeType && c.homeType.split(', ');
    const communityHomeType =
      communityHomeTypeList &&
      communityHomeTypeList.reduce((a, b) => {
        return a.concat(',' + b);
      });
    if ((!qmi || !qmi.length) && (!plans || !plans.length)) {
      if (
        (!citiesFilter || !citiesFilter.length) &&
        (!amenitiesFilter || !amenitiesFilter.length) &&
        (!communityStyleFilter || !communityStyleFilter.length) &&
        (!homeTypeFilter ||
          !homeTypeFilter.length ||
          (homeTypeFilter &&
            homeTypeFilter.length &&
            homeTypeFilter[0] === 'All')) &&
        !priceFilter
      ) {
        accum.push(c);
      } else {
        let hasCityFilter = true;
        let hasAmenitiesFilter = true;
        let hasCommunityStyleFilter = true;
        let hasHomeTypeFilter = true;
        let hasPriceFilter = true;

        if (citiesFilter && citiesFilter.length) {
          hasCityFilter = hasAttribute(citiesFilter, c.city);
        }
        if (amenitiesFilter && amenitiesFilter.length) {
          hasAmenitiesFilter = hasAttribute(amenitiesFilter, c.amenities);
        }
        if (communityStyleFilter && communityStyleFilter.length) {
          hasCommunityStyleFilter = hasAttribute(
            communityStyleFilter,
            c.communityStyles,
          );
        }
        if (
          homeTypeFilter &&
          homeTypeFilter.length &&
          homeTypeFilter[0] !== 'All'
        ) {
          hasHomeTypeFilter = hasAttribute(homeTypeFilter, communityHomeType);
        }
        if (
          priceFilter &&
          c.price &&
          c.price.price &&
          c.price.price.length > 2
        ) {
          const elementPrice = parseFloat(
            eval(c.price.price.replace(/\D/g, '')),
          );
          hasPriceFilter =
            (priceFilter.min ? elementPrice >= priceFilter.min : true) &&
            (priceFilter.max ? elementPrice <= priceFilter.max : true);
        }
        if (
          hasCityFilter &&
          hasAmenitiesFilter &&
          hasCommunityStyleFilter &&
          hasHomeTypeFilter &&
          hasPriceFilter
        ) {
          accum.push(c);
        }
      }
    } else {
      const filteredQmi = applyFilters(qmi, ...filters);
      const filteredPlans = applyFilters(plans, ...filters);
      let hasCommunityStyleFilter = true;
      let hasHomeTypeFilter = true;
      if (communityStyleFilter && communityStyleFilter.length) {
        hasCommunityStyleFilter = hasAttribute(
          communityStyleFilter,
          c.communityStyles,
        );
      }
      if (
        homeTypeFilter &&
        homeTypeFilter.length > 0 &&
        homeTypeFilter[0] !== 'All'
      ) {
        hasHomeTypeFilter = hasAttribute(homeTypeFilter, communityHomeType);
      }
      if (
        ((filteredQmi && filteredQmi.length) ||
          (filteredPlans && filteredPlans.length)) &&
        hasCommunityStyleFilter &&
        hasHomeTypeFilter
      ) {
        accum.push({ ...c, qmi: filteredQmi, plans: filteredPlans });
      }
    }
    return accum;
  }, []);

  // console.log({ filteredPlansAndQMITemp });

  let filteredPlansAndQMI = [...filteredPlansAndQMITemp];
  if (
    hasBedroomsFilter ||
    hasBathroomsFilter ||
    hasGarageFilter ||
    hasStoriesFilter
  ) {
    const filterCommunities = filteredPlansAndQMI.filter(
      (c) => c.plans || c.qmi,
    );
    filteredPlansAndQMI = [...filterCommunities];
  }
  const selectedCommunity = filters[SELECTED_COMMUNITY_FILTER_KEY];

  for (let i = 0; i < filteredPlansAndQMI.length; i++) {
    if (filteredPlansAndQMI[i].idMpc && filteredPlansAndQMI[i].type !== 'MPC') {
      const currentMPCPos = filteredPlansAndQMI.findIndex((c) => {
        return c.id === filteredPlansAndQMI[i].idMpc;
      });
      if (currentMPCPos < 1) {
        const CommunityMPC = communities.filter(
          (c) => c.id === filteredPlansAndQMI[i].idMpc,
        );
        if (CommunityMPC.length > 0) filteredPlansAndQMI.push(CommunityMPC[0]);
      }
    }
  }

  if (selectedCommunity.length === 1 && selectedCommunity[0].title === 'All') {
    return filteredPlansAndQMI;
  }

  let filteredCommunitiesandMPC = [];
  for (let i = 0; i < filteredPlansAndQMI.length; i++) {
    if (filteredPlansAndQMI[i].type === 'MPC') {
      const mpcId = filteredPlansAndQMI[i].id;
      let findMpcCommunities = filteredPlansAndQMI.find(
        (e) => e.type !== 'MPC' && e.idMpc === mpcId,
      );
      if (findMpcCommunities) {
        filteredCommunitiesandMPC.push(filteredPlansAndQMI[i]);
      }
    } else {
      filteredCommunitiesandMPC.push(filteredPlansAndQMI[i]);
    }
  }

  let resultFilteresByCommunityArray = [];
  for (let sC = 0; sC < selectedCommunity.length; sC++) {
    if (selectedCommunity.length > 0 && selectedCommunity[sC].title !== 'All') {
      if (selectedCommunity[sC].type === 'MPC') {
        resultFilteresByCommunityArray.push(selectedCommunity[sC]);
        const filteredMPCCommunities = filteredCommunitiesandMPC.filter(
          (c) => c.idMpc === selectedCommunity[sC].id,
        );
        for (let i = 0; i < filteredMPCCommunities; i++) {
          const communityExits = resultFilteresByCommunityArray.findIndex(
            (c) => {
              return c.id === filteredMPCCommunities[i].id;
            },
          );
          if (communityExits < 1) {
            resultFilteresByCommunityArray.push(filteredMPCCommunities[i]);
          }
        }
      } else {
        const filteredPlansAndQMICommunity = filteredCommunitiesandMPC.find(
          (c) => {
            return c.id === selectedCommunity[sC].id;
          },
        );
        const communityExits = resultFilteresByCommunityArray.findIndex((c) => {
          return c.id === selectedCommunity[sC].id;
        });
        if (filteredPlansAndQMICommunity && communityExits < 1) {
          resultFilteresByCommunityArray.push(filteredPlansAndQMICommunity);
        }
      }
    }
  }
  let cleanEmptyMPCs = [];

  for (let i = 0; i < resultFilteresByCommunityArray.length; i++) {
    if (resultFilteresByCommunityArray[i].type === 'MPC') {
      let MPCCommunitiesList = resultFilteresByCommunityArray.filter(
        (c) =>
          c.idMpc === resultFilteresByCommunityArray[i].id && c.type !== 'MPC',
      );
      if (MPCCommunitiesList.length > 0) {
        cleanEmptyMPCs.push(resultFilteresByCommunityArray[i]);
      }
    } else {
      cleanEmptyMPCs.push(resultFilteresByCommunityArray[i]);
    }
  }

  return cleanEmptyMPCs;
};

const getMinAttr = (label) => {
  const labelValues = label.split(' ');
  if (labelValues && labelValues.length > 0) {
    return labelValues[0] === '0' ? 99 : labelValues[0];
  }
  return 99;
};
const getMaxAttr = (label) => {
  const labelValues = label.split(' ');
  if (labelValues && labelValues.length > 0) {
    if (labelValues[1] === '-') {
      return labelValues[2] === '0' ? 0 : labelValues[0];
    }
    return labelValues[0] === '0' ? 0 : labelValues[0];
  }
  return 0;
};

const MetroSearch = ({ rendering }) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  const { favoritesList, saveFavorite, deleteFavorite } = useFavorites();
  const [{ notificationActive, nationalNotificationHeight }] = useUiValue();

  const location = useLocation();
  const params = queryString.parse(location.search);
  const navigate = useNavigate();

  // const { geolocation = {} } = useSitecoreContext() || {};
  // const latLng = { lat: geolocation.latitude, lng: geolocation.longitude };
  // console.log(geolocation, latLng);

  const initialProductType = params.productType || searchProductTypes.COMMUNITY;
  const initialPriceFilter =
    params.minPrice || params.maxPrice
      ? {
          min: parseInt(params.minPrice),
          max: parseInt(params.maxPrice),
        }
      : undefined;
  const bedroomsParam = params.bedrooms
    ? params.bedrooms.split(',').map(function (item) {
        return parseFloat(item, 10);
      })
    : [];
  const bathroomsParam = params.bathrooms
    ? params.bathrooms.split(',').map(function (item) {
        return parseInt(item, 10);
      })
    : [];
  const initialBedroomsFilter = bedroomsParam.length > 0 ? bedroomsParam : [];
  const initialBathroomsFilter =
    bathroomsParam.length > 0 ? bathroomsParam : [];

  const initialHomeTypeFilter = params.homeType
    ? params.homeType.split(',')
    : ['All'];
  const initialStateMap = params.hideMap === 'true';

  const [fields, setFields] = useState({});
  const [productType, setProductType] = useState(initialProductType);
  const [productTypeBefore, setProductTypeBefore] =
    useState(initialProductType);
  const [selectedMetro, setSelectedMetro] = useState();
  const [selectedState, setSelectedState] = useState();
  const [initialCommunities, setInitialCommunities] = useState(
    params.community,
  );
  const [selectedCommunity, setSelectedCommunity] = useState([
    { id: null, title: 'All' },
  ]);
  const [visibleInMapIds, setVisibleInMapIds] = useState([]);
  const [mapReported, setMapReported] = useState(false);
  const [useMapViewportFilter, setUseMapViewportFilter] = useState(false);
  const [{ country }] = useCountryValue();
  const [showMap, setShowMap] = useState(!initialStateMap);
  const [showMobileCard, setShowMobileCard] = useState(false);
  const [hideMap, setHideMap] = useState(initialStateMap);
  const [resetBounds, setResetBounds] = useState(false);
  const resetBoundsRef = useRef(false);
  const [mapMounted, setMapMounted] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState();

  const [priceFilter, setPriceFilter] = useState(initialPriceFilter);
  const [sizeFilter, setSizeFilter] = useState();
  const [sort, setSort] = useState();
  const [metroCommunityIDsCustomSort, setMetroCommunityIDsCustomSort] =
    useState();
  const [hasCustomSortFeatured, setHasCustomSortFeatured] = useState(false);

  const [homeType, setHomeType] = useState(initialHomeTypeFilter);
  const [citiesFilter, setCitiesFilter] = useState();
  const [amenitiesFilter, setAmenitiesFilter] = useState();
  const [communityStylesFilter, setCommunityStylesFilter] = useState();

  const [lotSizeFilter, setLotSizeFilter] = useState();
  const [productLineFilter, setProductLineFilter] = useState();
  const [hasDen, setHasDen] = useState(false);
  const [bedroomsFilter, setBedroomsFilter] = useState(initialBedroomsFilter);
  const [bathroomsFilter, setBathroomsFilter] = useState(
    initialBathroomsFilter,
  );
  const [storiesFilter, setStoriesFilter] = useState([]);
  const [garagesFilter, setGaragesFilter] = useState([]);
  const [isRVSelected, setIsRVSelected] = useState(false);
  const [fetchCounter, setFetchCounter] = useState(0);
  const [temporalShowMapMobile, setTemporalShowMapMobile] = useState(true);
  const searchResultRef = useRef(null);
  const moreFiltersModalButtonRef = useRef(null);
  const [moreFilters, setMoreFilters] = useState(false);
  const [availableOptions, setAvailableOptions] = useState({});
  const [promoBannerFields, setPromoBannerFields] = useState({});
  const { updateMetroSearchSelectedMetro } = useMetroSearchSelectedMetro();

  const primaryFilterCommunityRef = useRef();

  const priceRangeMin = getFieldValue(
    fields,
    country === 'USA' ? 'usaPriceRangeMin' : 'caPriceRangeMin',
  );
  const priceRangeMax = getFieldValue(
    fields,
    country === 'USA' ? 'usaPriceRangeMax' : 'caPriceRangeMax',
  );

  const productTypeTitle = getProductTypeTitle(fields, productType);

  const mapData = ({ communityCards, planCards, qmiCards, mpcCards }) => {
    if (!communityCards) return [];
    let newMPCCards = [];
    for (let i = 0; i < mpcCards.value.length; i++) {
      const MPCCommunities = communityCards.value.filter(
        (c) => c.idMpc === mpcCards.value[i].id,
      );
      if (MPCCommunities.length > 0) newMPCCards.push(mpcCards.value[i]);
    }

    communityCards.value = communityCards.value.concat(newMPCCards);
    let result = communityCards.value.reduce((accum, community) => {
      const key = `${community.id}`;
      accum[key] = community;
      return accum;
    }, {});

    result = mapProducts(result, planCards.value, 'plans');
    result = mapProducts(result, qmiCards.value, 'qmi');

    for (let community in result) {
      const amenities = result[community].amenities;
      const communityStyles = result[community].communityStyles;
      const city = result[community].city;
      let minBaths = 99,
        maxBaths = 0,
        minBeds = 99,
        maxBeds = 0,
        minCars = 99,
        maxCars = 0,
        minStories = 99,
        maxStories = 0;
      if (result[community].plans && result[community].plans.length > 0) {
        for (let p = 0; p < result[community].plans.length; p++) {
          result[community].plans[p].amenities = amenities;
          result[community].plans[p].communityStyles = communityStyles;
          result[community].plans[p].city = city;
          const attr = result[community].plans[p].attributes;

          const beds = attr.find((e) => e && e.icon === 'bed') || {};
          const rmnBeds = getMinAttr(beds && beds.label);
          const rmxBeds = getMaxAttr(beds && beds.label);
          minBeds = rmnBeds < minBeds ? rmnBeds : minBeds;
          maxBeds = rmxBeds > maxBeds ? rmxBeds : maxBeds;

          const baths = attr.find((e) => e && e.icon === 'bath') || {};
          const rmnBaths = getMinAttr(baths && baths.label);
          const rmxBaths = getMaxAttr(baths && baths.label);
          minBaths = rmnBaths < minBaths ? rmnBaths : minBaths;
          maxBaths = rmxBaths > maxBaths ? rmxBaths : maxBaths;

          const cars = attr.find((e) => e && e.icon === 'car') || {};
          const rmnCars = getMinAttr(cars && cars.label);
          const rmxCars = getMaxAttr(cars && cars.label);
          minCars = rmnCars < minCars ? rmnCars : minCars;
          maxCars = rmxCars > maxCars ? rmxCars : maxCars;
          const stories = attr.find((e) => e && e.icon === 'stories') || {};
          const rmnStories = getMinAttr(stories && stories.label);
          const rmxStories = getMaxAttr(stories && stories.label);
          minStories = rmnStories < minStories ? rmnStories : minStories;
          maxStories = rmxStories > maxStories ? rmxStories : maxStories;
        }
      }
      if (result[community].qmi && result[community].qmi.length > 0) {
        for (let p = 0; p < result[community].qmi.length; p++) {
          result[community].qmi[p].amenities = amenities;
          result[community].qmi[p].communityStyles = communityStyles;
          result[community].qmi[p].city = city;
          const attr = result[community].qmi[p].attributes;

          const beds = attr.find((e) => e && e.icon === 'bed') || {};
          const rmnBeds = getMinAttr(beds && beds.label);
          minBeds = rmnBeds < minBeds ? rmnBeds : minBeds;
          maxBeds = rmnBeds > maxBeds ? rmnBeds : maxBeds;

          const baths = attr.find((e) => e && e.icon === 'bath') || {};
          const rmnBaths = getMinAttr(baths && baths.label);
          minBaths = rmnBaths < minBaths ? rmnBaths : minBaths;
          maxBaths = rmnBaths > maxBaths ? rmnBaths : maxBaths;

          const cars = attr.find((e) => e && e.icon === 'car') || {};
          const rmnCars = getMinAttr(cars && cars.label);
          minCars = rmnCars < minCars ? rmnCars : minCars;
          maxCars = rmnCars > maxCars ? rmnCars : maxCars;

          const stories = attr.find((e) => e && e.icon === 'stories') || {};
          const rmnStories = getMinAttr(stories && stories.label);
          minStories = rmnStories < minStories ? rmnStories : minStories;
          maxStories = rmnStories > maxStories ? rmnStories : maxStories;
        }
      }
      if (result[community].plans || result[community].qmi) {
        result[community].attributes = [
          {
            icon: 'bath',
            label: minBaths + ' - ' + maxBaths + ' Baths',
            attribute: null,
          },
          // { icon: "half-baths", label: "1 Half Bath", attribute: null },
          {
            icon: 'bed',
            label: minBeds + ' - ' + maxBeds + ' Beds',
            attribute: null,
          },
          // { icon: "ruler", label: "2,359 Sq. Ft.", attribute: null },
          {
            icon: 'car',
            label: minCars + ' - ' + maxCars + ' Car Garages',
            attribute: null,
          },
          {
            icon: 'stories',
            label: minStories + ' - ' + maxStories + ' Stories',
            attribute: null,
          },
        ];
      } else {
        result[community].attributes = [
          {
            icon: 'bath',
            label: '0 - 0 Baths',
            attribute: null,
          },
          // { icon: "half-baths", label: "1 Half Bath", attribute: null },
          {
            icon: 'bed',
            label: '0 - 0 Beds',
            attribute: null,
          },
          // { icon: "ruler", label: "2,359 Sq. Ft.", attribute: null },
          {
            icon: 'car',
            label: '0 - 0 Car Garages',
            attribute: null,
          },
          {
            icon: 'stories',
            label: '0 - 0 Stories',
            attribute: null,
          },
        ];
      }
    }
    let totalPlans = 0;
    let totalQMIs = 0;
    for (let key in result) {
      if (result[key].plans) totalPlans = totalPlans + result[key].plans.length;
      if (result[key].qmi) totalQMIs = totalQMIs + result[key].qmi.length;
    }
    return result;
  };

  const fetchMetroData = (metro, countryParam) => {
    if (!config) {
      return;
    }
    if (metro && metro.country !== countryParam) {
      return;
    }
    if (metro && metro.state.toLowerCase() === selectedState) {
      setIsLoading(false);
      return;
    }

    const baseUrl =
      config.sitecoreApiHost +
      '/sitecore/api/layout/render/jss?item=/search-data&sc_apikey=' +
      config.sitecoreApiKey;

    const metroParam = params.metro || '';

    // const market = metro ? metro.name.toLowerCase() : metroParam;
    const market = metro ? metro.name : metroParam;

    const isState = metro
      ? metro.name.toLowerCase() === metro.state.toLowerCase()
        ? '1'
        : '0'
      : '';

    setFetchCounter(fetchCounter + 1);
    // console.log(baseUrl, market, isState, fetchCounter);
    return fetch(`${baseUrl}&market=${market}&IsState=${isState}`)
      .then((res) => res.json())
      .then((res) => {
        try {
          // console.log({ res });
          // console.log("1");
          let data = res.sitecore.route.placeholders['jss-main'][0].fields;

          // console.log("2");
          const filteredData = filterNoLatLngCards(data);
          setFields(filteredData);

          if (metro) {
            setIsLoading(false);
            setSelectedState(metro.state.toLowerCase());
          }

          if (!metro) {
            // console.log({ data, countryParam, metroParam });
            setSelectedMetro(
              // getSelectedMetroFromQuery(data, countryParam, metroParam, latLng)
              getSelectedMetroFromQuery(data, countryParam, metroParam),
            );
          }
          // console.log("4");
          setFetchCounter(0);
        } catch (e) {
          // console.log(e, fetchCounter);
          if (fetchCounter < 2) {
            fetchMetroData(metro, countryParam);
          }
        }
      });
  };

  const metros = getFieldValue(fields, 'metrosFilter');
  const populatedCommunities = useMemo(() => mapData(fields), [fields]);
  const sitecoreFilters = getFieldValue(fields, 'moreFilters');
  const mortgageAmounts = getFieldValue(fields, 'mortgageAmounts');
  const priceDifferentialText =
    country === 'USA'
      ? getFieldValue(fields, 'priceDifferentialTextUSA')
      : getFieldValue(fields, 'priceDifferentialTextCAN');
  const promotionBannerValues = getFieldValue(fields, 'promotionBanner');
  const withMultipleSelection =
    country === 'USA'
      ? getFieldValue(fields, 'usMarketSelectors')
      : getFieldValue(fields, 'canadaMarketSelectors');
  const statesCustomSort = getFieldValue(fields, 'statesCustomSort');

  const filters = [
    priceFilter,
    bedroomsFilter,
    sizeFilter,
    homeType,
    selectedCommunity,
    citiesFilter,
    amenitiesFilter,
    bathroomsFilter,
    garagesFilter,
    lotSizeFilter,
    productLineFilter,
    storiesFilter,
    communityStylesFilter,
    hasDen,
    selectedMetro,
    isRVSelected,
  ];

  const atlasRTXChatbotScript =
    country === 'USA'
      ? getFieldValue(fields, 'atlasRTXChatbotScript')
      : getFieldValue(fields, 'canadaAtlasRTXChatbotScript');
  const atlasRTXSearchValues = getFieldValue(fields, 'atlasRTXSearchValues');
  useEffect(() => {
    if (
      atlasRTXChatbotScript &&
      document &&
      typeof window !== 'undefined' &&
      country &&
      atlasRTXSearchValues &&
      selectedMetro &&
      selectedMetro[0]
    ) {
      const updateParamsScript = atlasRTXChatbotScript.replace(
        '"params":{}',
        '"params":{"state":"{atlas_state}","areaName":"{atlas_areaName}"}',
      );
      const updateContextScript = updateParamsScript.replace(
        '"segmentationContext":{}',
        '"segmentationContext":{"division":"{atlas_division}"}',
      );

      const isStateSelected =
        selectedMetro[0].name.toLowerCase() ===
        selectedMetro[0].state.toLowerCase();
      const updateStateScript = updateContextScript.replace(
        '{atlas_state}',
        selectedMetro[0].state,
      );
      const atlasRTXValues = isStateSelected
        ? { areaName: '', divisionCode: '' }
        : atlasRTXSearchValues.find(
            (e) =>
              e.areaName.toLowerCase() === selectedMetro[0].name.toLowerCase(),
          );
      const updateMetroScript = updateStateScript.replace(
        '{atlas_areaName}',
        atlasRTXValues.areaName,
      );
      const updateDivisionScript = updateMetroScript.replace(
        '{atlas_division}',
        atlasRTXValues.divisionCode,
      );

      const scriptList = document.querySelectorAll(
        "script[type='text/javascript']",
      );
      const convertedNodeList = Array.from(scriptList);
      const testScript = convertedNodeList.find((script) =>
        script.innerText.includes('atlasSettings'),
      );
      //if (testScript) testScript.parentNode.removeChild(testScript);
      //const atlasChatDiv = document.getElementById('iAtlasChatDiv');
      //if (atlasChatDiv) atlasChatDiv.remove();

      //Removing before testScript data
      let isSameScript = false;
      if (testScript) {
        //console.log(testScript.innerText, atlasRTXValues);
        if (
          testScript.innerText.includes(atlasRTXValues.areaName) &&
          testScript.innerText.includes(atlasRTXValues.divisionCode) &&
          selectedMetro[0].state
        ) {
          isSameScript = true;
        } else {
          testScript.parentNode.removeChild(testScript);
          const atlasChatDiv = document.getElementById('iAtlasChatDiv');
          if (atlasChatDiv) atlasChatDiv.remove();
        }
      }
      if (!isSameScript) {
        const snipped = document
          .createRange()
          .createContextualFragment(updateDivisionScript);
        if (snipped) {
          console.info('[ATLAS CHATBOT] Loaded script');
          document.head.appendChild(snipped);
        }
      }
    }
  }, [country, atlasRTXChatbotScript, atlasRTXSearchValues, selectedMetro]);

  useEffect(() => {
    const hasBedroomsFilter =
      bedroomsFilter &&
      bedroomsFilter.length > 0 &&
      ((hasDen && bedroomsFilter.length !== 7) ||
        (!hasDen && bedroomsFilter.length !== 4));
    const hasBathroomsFilter =
      bathroomsFilter &&
      bathroomsFilter.length > 0 &&
      bathroomsFilter.length !== 4;
    const hasGarageFilter = garagesFilter && garagesFilter.length > 0;
    const hasStoriesFilter = storiesFilter && storiesFilter.length > 0;

    if (
      !hideMap &&
      !isMobile &&
      !resetBounds &&
      !hasBedroomsFilter &&
      !hasBathroomsFilter &&
      !hasGarageFilter &&
      !hasStoriesFilter &&
      !(citiesFilter && citiesFilter.length > 0) &&
      !(amenitiesFilter && amenitiesFilter.length > 0) &&
      !(communityStylesFilter && communityStylesFilter.length > 0) &&
      !(homeType && homeType.length > 0 && homeType[0] !== 'All') &&
      !(lotSizeFilter && lotSizeFilter.length > 0) &&
      !(productLineFilter && productLineFilter.length > 0) &&
      !(priceFilter && (priceFilter.min > 0 || priceFilter.max > 0))
    ) {
      // console.log("resetBounds here! 1306");
      setResetBounds(true);
    }
  }, [
    priceFilter,
    bedroomsFilter,
    sizeFilter,
    homeType,
    citiesFilter,
    amenitiesFilter,
    bathroomsFilter,
    garagesFilter,
    lotSizeFilter,
    productLineFilter,
    storiesFilter,
    communityStylesFilter,
    hasDen,
    selectedMetro,
    hideMap,
    showMap,
    // Guards the `!isMobile` branch above; resolves only after mount.
    isMobile,
  ]);

  let filteredCards = useMemo(
    () =>
      productType === searchProductTypes.COMMUNITY
        ? filterCommunities(
            Object.values(populatedCommunities), //
            ...filters,
            showMap,
            !isMobile && hideMap,
          )
        : filterCards(
            populatedCommunities,
            productType,
            ...filters,
            showMap,
            !isMobile && hideMap,
          ), //
    [
      productType,
      selectedCommunity,
      priceFilter,
      bedroomsFilter,
      sizeFilter,
      homeType,
      populatedCommunities, // populatedCommunities,
      citiesFilter,
      amenitiesFilter,
      bathroomsFilter,
      garagesFilter,
      lotSizeFilter,
      productLineFilter,
      storiesFilter,
      communityStylesFilter,
      hasDen,
      selectedMetro,
      showMap,
      hideMap,
      isMobile,
      isRVSelected,
    ],
  );

  useEffect(() => {
    const newParams = {
      ...params,
      country,
      productType,
      hideMap,
    };

    if (hideMap) {
      newParams.hideMap = hideMap;
    }
    if (priceFilter) {
      if (!isNaN(priceFilter.min)) {
        newParams.minPrice = priceFilter.min;
      } else {
        delete newParams.minPrice;
      }
      if (!isNaN(priceFilter.max)) {
        newParams.maxPrice = priceFilter.max;
      } else {
        delete newParams.maxPrice;
      }
    } else {
      delete newParams.maxPrice;
      delete newParams.minPrice;
    }
    if (homeType) {
      // console.log({ homeType });
      if (homeType.length > 0) {
        let homeTypeNewParams = [];
        for (let h = 0; h < homeType.length; h++) {
          homeTypeNewParams.push(homeType[h]);
        }
        // console.log({ homeTypeNewParams });
        newParams.homeType = homeTypeNewParams;
      } else {
        newParams.homeType = 'All';
      }
    } else {
      delete newParams.homeType;
    }
    if (bedroomsFilter && bedroomsFilter.length > 0) {
      let bedroomsParams = [];
      for (let b = 0; b < bedroomsFilter.length; b++) {
        bedroomsParams.push(bedroomsFilter[b]);
      }
      newParams.bedrooms = bedroomsParams;
    } else {
      delete newParams.bedrooms;
    }
    if (bathroomsFilter && bathroomsFilter.length > 0) {
      let bathroomsParams = [];
      for (let b = 0; b < bathroomsFilter.length; b++) {
        bathroomsParams.push(bathroomsFilter[b]);
      }
      newParams.bathrooms = bathroomsParams;
    } else {
      delete newParams.bathrooms;
    }
    if (selectedCommunity) {
      if (selectedCommunity.length > 1) {
        let communitiesParams = [];
        for (let c = 1; c < selectedCommunity.length; c++) {
          communitiesParams.push(selectedCommunity[c].title);
        }
        newParams.community = communitiesParams;
      } else {
        newParams.community = initialCommunities ? initialCommunities : 'All';
      }
    }
    if (selectedMetro) {
      // console.log({ selectedMetro });
      if (selectedMetro.length > 0) {
        let metrosNewParams = [];
        for (let m = 0; m < selectedMetro.length; m++) {
          metrosNewParams.push(selectedMetro[m].name);
        }
        // console.log({ metrosNewParams });
        newParams.metro = metrosNewParams;
      }

      // newParams.metro = selectedMetro[0].name;
    }

    if (citiesFilter && citiesFilter.length > 0) {
      newParams.city = citiesFilter;
    } else delete newParams.city;

    if (productLineFilter && productLineFilter.length > 0) {
      newParams.productLine = productLineFilter;
    } else delete newParams.productLine;

    // console.log(params, productType, newParams);
    navigate({
      pathname: location.pathname,
      search: '?' + new URLSearchParams(newParams).toString(),
    });
  }, [
    productType,
    selectedMetro,
    selectedCommunity,
    priceFilter,
    bedroomsFilter,
    bathroomsFilter,
    homeType,
    country,
    hideMap,
    citiesFilter,
    productLineFilter,
  ]);

  const updatePushBackFilters = (searchParams) => {
    const newParams = new URLSearchParams(searchParams);
    if (searchParams) {
      // console.log("updatePushBackFilters", paramsList);
      // const newCountry = newParams.get("country");
      // const newCommunities = newParams.get("community");
      const newMetro = newParams.get('metro');
      const newProductType = newParams.get('productType');

      const newMinPrice = newParams.get('minPrice');
      const newMaxPrice = newParams.get('maxPrice');
      const newBedrooms = newParams.get('bedrooms');
      const newBathrooms = newParams.get('bathrooms');

      const newHomeType = newParams.get('homeType');
      const newHideMap = newParams.get('hideMap');
      const newCities = newParams.get('city');

      if (typeof newProductType !== 'undefined') {
        if (newProductType !== productType) {
          // console.log({productType, newProductType});
          setProductType(newProductType);
        }
      }
      if (typeof newHomeType !== 'undefined') {
        const homeTypeList = newHomeType && newHomeType.split(',');
        if (homeTypeList.length > 0 && homeTypeList[0] !== 'All') {
          setHomeType(homeTypeList ? homeTypeList : ['All']);
        }
      }
      if (typeof newHideMap !== 'undefined') {
        const newHideMapBool = newHideMap === 'true' ? true : false;
        if (newHideMapBool !== hideMap) {
          setHideMap(newHideMapBool);
          setShowMap(!newHideMapBool);
        }
      }
      let minPriceChange = false;
      let maxPriceChange = false;
      if (
        typeof priceFilter !== 'undefined' &&
        typeof newMinPrice !== 'undefined'
      ) {
        if (priceFilter.min && newMinPrice !== priceFilter.min) {
          minPriceChange = true;
        }
      }
      if (
        typeof priceFilter !== 'undefined' &&
        typeof newMaxPrice !== 'undefined'
      ) {
        if (priceFilter.max && newMaxPrice !== priceFilter.max) {
          maxPriceChange = true;
        }
      }
      if (minPriceChange && maxPriceChange) {
        setPriceFilter({
          min: newMinPrice,
          max: newMaxPrice,
        });
      } else {
        if (minPriceChange) {
          setPriceFilter({ min: newMinPrice.slice(9), max: priceFilter.max });
        }

        if (maxPriceChange) {
          setPriceFilter({ max: newMaxPrice.slice(9), min: priceFilter.min });
        }
      }

      if (typeof newMetro !== 'undefined') {
        if (
          selectedMetro &&
          selectedMetro[0] &&
          newMetro !== selectedMetro[0].name
        ) {
          /* const newMetroSelected = getSelectedMetroFromQuery(
            fields,
            country,
            newMetro,
            latLng
          );*/
          const newMetroSelected = getSelectedMetroFromQuery(
            fields,
            country,
            newMetro,
          );
          setSelectedMetro(newMetroSelected);
        }
      }

      if (
        typeof newBedrooms !== 'undefined' &&
        typeof newBedrooms !== 'undefined'
      ) {
        const bedsList = newBedrooms && newBedrooms.split(',');
        setBedroomsFilter(bedsList ? bedsList : []);
      }

      if (
        typeof newBathrooms !== 'undefined' &&
        typeof newBathrooms !== 'undefined' &&
        newBathrooms
      ) {
        const bathsList = newBathrooms && newBathrooms.split(',');
        setBathroomsFilter(bathsList ? bathsList : []);
      }

      if (
        typeof citiesFilter !== 'undefined' &&
        typeof newCities !== 'undefined' &&
        newCities
      ) {
        const citiesList = newCities && newCities.split(',');
        setCitiesFilter(citiesList ? citiesList : []);
      }

      /*
      console.log({ newCommunities });
      console.log({
        selectedCommunity,
      });
    if (selectedCommunity) {
      if (selectedCommunity.length > 1) {
        let communitiesParams = [];
        for (let c = 1; c < selectedCommunity.length; c++) {
          communitiesParams.push(selectedCommunity[c].title);
        }
        newParams.community = communitiesParams;
      } else {
        newParams.community = initialCommunities ? initialCommunities : "All";
      }
    }*/
      /* country,-
      selectedCommunity,-
      productLineFilter,*/
    }
  };

  //const [locationKeys, setLocationKeys] = useState([]);
  /* commented the pushback implementation
  const navType = useNavigationType(); // 'POP' | 'PUSH' | 'REPLACE'
  const locationKeysRef = useRef([]); // similar a tu state locationKeys
  useEffect(() => {
    if (navType === 'PUSH') {
      if (location.key) locationKeysRef.current = [location.key];
    }

    if (navType === 'POP') {
      // forward
      if (locationKeysRef.current[1] === location.key) {
        locationKeysRef.current = locationKeysRef.current.slice(1);
      } else {
        // back
        locationKeysRef.current = [location.key, ...locationKeysRef.current];
        updatePushBackFilters(location.search);
      }
    }
  }, [navType, location.key, location.search]); */

  /* useEffect(() => {
    if (metros) {
      clearFilters();
      setSelectedMetro();
      setSelectedCommunity([{ id: null, title: "All" }]);
    }
  }, [country]);*/

  useEffect(() => {
    if (metros) {
      // clearFilters();
      setBedroomsFilter([]);
    }
  }, [hasDen]);

  useEffect(() => {
    const tempHasDen =
      typeof filteredCards.find((c) => {
        if (c.type === 'Plan') return c.isCondo && c.den;
        if (c.type === 'Community') {
          const findDenOnPlans =
            c.plans &&
            c.plans.length > 0 &&
            c.plans.find((p) => p.isCondo && p.den);
          if (typeof findDenOnPlans !== 'undefined') {
            return true;
          }
        }
        return false;
      }) !== 'undefined';
    setHasDen(tempHasDen);
  }, [fields]);

  useEffect(() => {
    if (params.city) {
      var listOfCities = params.city.split(',');
      if (listOfCities) {
        setCitiesFilter(listOfCities);
      }
    }
  }, [setCitiesFilter]);

  useEffect(() => {
    if (params.productLine) {
      var listOfProductLines = params.productLine.split(',');
      if (listOfProductLines) {
        setProductLineFilter(listOfProductLines);
      }
    }
  }, [setProductLineFilter]);

  useEffect(() => {
    const communities = getFieldValue(fields, 'communityCards');
    if (Array.isArray(communities) && params.community) {
      if (communities) {
        const comunityParam = params.community;
        const communitiesList = comunityParam.split(',');
        const newListOfCommunities = [...selectedCommunity];
        for (let i = 0; i < communitiesList.length; i++) {
          const community = communities.find(
            (c) => c.title.toLowerCase() === communitiesList[i].toLowerCase(),
          );
          if (community) newListOfCommunities.push(community);
        }

        if (newListOfCommunities && newListOfCommunities.length > 0) {
          setSelectedCommunity(newListOfCommunities);
        } else {
          setSelectedCommunity([{ id: null, title: 'All' }]);
        }
      }
    }
  }, [fields]);

  useEffect(() => {
    // console.log({ selectedMetro, country });
    if (
      selectedMetro &&
      selectedMetro[0] &&
      country !== selectedMetro[0].country
    ) {
      // console.log("setSelectedMetro()");
      setSelectedMetro();
    }
    if (country) {
      // console.log(country, metros);
      if (!(selectedMetro && selectedMetro[0]) && metros) {
        /* const newSelectedMetro = getSelectedMetroFromQuery(
          fields,
          country,
          "",
          latLng
        );*/
        const newSelectedMetro = getSelectedMetroFromQuery(fields, country, '');
        // console.log("newSelectedMetro", newSelectedMetro)
        setSelectedMetro(newSelectedMetro);
        clearFilters();
      } else {
        // console.log(selectedMetro);
        fetchMetroData(selectedMetro && selectedMetro[0], country);
        if (
          selectedMetro &&
          selectedMetro[0] &&
          selectedMetro[0].state.toLowerCase() !== selectedState
        ) {
          setIsLoading(true);
        }
      }
    }
  }, [selectedMetro, country]);

  const handleMetroChange = (metro, flag = false) => {
    // console.log(selectedMetro, metro);
    if (
      selectedMetro &&
      selectedMetro[0] &&
      selectedMetro[0].state.toLowerCase() === metro.state.toLowerCase()
    ) {
      const isStateSelected = selectedMetro.find(
        (e) => e.state.toLowerCase() === e.name.toLowerCase(),
      );
      const isMetroState =
        metro.state.toLowerCase() === metro.name.toLowerCase();
      if (isStateSelected || isMetroState || flag) {
        setSelectedMetro([metro]);
      } else {
        const newSelectedMetro = [...selectedMetro];
        const mValueIndex = newSelectedMetro.findIndex(
          (e) => e.name.toLowerCase() === metro.name.toLowerCase(),
        );
        if (mValueIndex >= 0) {
          newSelectedMetro.splice(mValueIndex, 1);
        } else {
          newSelectedMetro.push(metro);
        }
        if (newSelectedMetro.length > 0) setSelectedMetro(newSelectedMetro);
      }
    } else {
      setSelectedMetro([metro]);
    }
    setSelectedCommunity([{ id: null, title: 'All' }]);
    clearFilters();
  };

  const handleSortChange = (value) => {
    setSort(value);
  };

  const handleHomeTypeChange = (value, selectAll) => {
    if (selectAll) {
      setHomeType(['All']);
    } else {
      const newHomeTypes = [...homeType];
      const allValueIndex = newHomeTypes.findIndex((e) => e === 'All');
      if (allValueIndex >= 0) {
        newHomeTypes.splice(allValueIndex, 1);
      }
      const htvalueIndex = newHomeTypes.findIndex((e) => e === value);
      if (htvalueIndex >= 0) {
        newHomeTypes.splice(htvalueIndex, 1);
      } else {
        newHomeTypes.push(value);
      }
      if (newHomeTypes.length > 0) setHomeType(newHomeTypes);
      else setHomeType(['All']);
    }
  };

  const handleCommunityChange = (community) => {
    if (community.id) {
      const listOfSelectedCommunities = [...selectedCommunity];
      const currentPos = listOfSelectedCommunities.findIndex((c) => {
        return c.id === community.id;
      });

      if (currentPos > 0) {
        if (community.type === 'Community') {
          if (community.idMpc) {
            listOfSelectedCommunities.splice(currentPos, 1);
            const comunityMPC = listOfSelectedCommunities.findIndex(
              (c) => c.id === community.idMpc,
            );
            if (comunityMPC > 0) {
              const communitiesofMPC = listOfSelectedCommunities.filter(
                (c) => c.idMpc === community.idMpc && c.id !== community.idMpc,
              );
              if (communitiesofMPC.length < 1) {
                listOfSelectedCommunities.splice(comunityMPC, 1);
              }
            }
          } else {
            listOfSelectedCommunities.splice(currentPos, 1);
          }
        } else {
          listOfSelectedCommunities.splice(currentPos, 1);
          const communitiesofMPC = listOfSelectedCommunities.filter(
            (c) => c.idMpc === community.id,
          );
          for (let i = 0; i < communitiesofMPC.length; i++) {
            const communityIndex = listOfSelectedCommunities.findIndex((c) => {
              return c.id === communitiesofMPC[i].id;
            });
            if (communityIndex > 0) {
              listOfSelectedCommunities.splice(communityIndex, 1);
            }
          }
        }
      } else {
        if (community.type === 'Community') {
          listOfSelectedCommunities.push(community);
          const currentMPCPos = listOfSelectedCommunities.findIndex((c) => {
            return c.id === community.idMpc;
          });
          if (currentMPCPos < 1) {
            const CommunityMPC = originCommunitiesCards.filter(
              (c) => c.id === community.idMpc,
            );
            if (CommunityMPC.length > 0) {
              listOfSelectedCommunities.push(CommunityMPC[0]);
            }
          }
        } else {
          listOfSelectedCommunities.push(community);
          const communitiesofMPC = originCommunitiesCards.filter(
            (c) => c.idMpc === community.id,
          );
          for (let i = 0; i < communitiesofMPC.length; i++) {
            const communityExits = listOfSelectedCommunities.findIndex((c) => {
              return c.id === communitiesofMPC[i].id;
            });
            if (communityExits <= 0) {
              listOfSelectedCommunities.push(communitiesofMPC[i]);
            }
          }
        }
      }
      setSelectedCommunity(listOfSelectedCommunities);
    } else {
      setSelectedCommunity([{ id: null, title: 'All' }]);
      setInitialCommunities();
    }
  };

  const handlePrimaryFilterChange = (product) => {
    setProductTypeBefore(productType);
    // console.log({productType, product});
    setProductType(product);
    if (product === searchProductTypes.COMMUNITY) {
      let metroCommunityDefaultSort = '';
      const isState =
        selectedMetro &&
        selectedMetro[0] &&
        selectedMetro[0].name.toLowerCase() ===
          selectedMetro[0].state.toLowerCase();
      if (selectedMetro && selectedMetro.length > 0) {
        if (isState) {
          metroCommunityDefaultSort =
            (selectedMetro[0] &&
              selectedMetro[0].cities[0] &&
              selectedMetro[0].cities[0].stateCommunityDefaultSort) ||
            '';
        } else {
          metroCommunityDefaultSort =
            (selectedMetro[0] && selectedMetro[0].metroCommunityDefaultSort) ||
            '';
        }
      } else
        metroCommunityDefaultSort =
          selectedMetro.metroCommunityDefaultSort || '';
      //console.log({ selectedMetro, metroCommunityDefaultSort });
      const defaultSort =
        metroCommunityDefaultSort === 'Alphabetical'
          ? 'title'
          : metroCommunityDefaultSort === 'Price'
          ? 'price'
          : metroCommunityDefaultSort === 'Custom'
          ? 'custom'
          : 'availability';
      setSort(defaultSort);
      if (defaultSort === 'custom') setHasCustomSortFeatured(true);
      else setHasCustomSortFeatured(false);
    } else if (product === searchProductTypes.QMI) {
      //console.log({ selectedMetro });
      if (selectedCommunity && selectedCommunity.length > 1) {
        //console.log({ selectedMetro });
        let lastCommunitySelectedIndex = selectedCommunity.length - 1;

        for (let i = selectedCommunity.length - 1; i > 0; i--) {
          if (selectedCommunity[i].type === 'Community') {
            lastCommunitySelectedIndex = i;
            break;
          }
        }

        const lastCommunitySelected =
          selectedCommunity[lastCommunitySelectedIndex];
        const communityQMIDefaultSort =
          lastCommunitySelected.community_QMIDefaultSort;

        const newQMISort =
          communityQMIDefaultSort === 'Alphabetical'
            ? 'title'
            : communityQMIDefaultSort === 'Price'
            ? 'price'
            : 'date';
        setSort(newQMISort);
      } else {
        let metroQMIDefaultSort = '';
        const isState =
          selectedMetro &&
          selectedMetro[0] &&
          selectedMetro[0].name.toLowerCase() ===
            selectedMetro[0].state.toLowerCase();
        if (selectedMetro && selectedMetro.length > 0) {
          if (isState) {
            metroQMIDefaultSort =
              (selectedMetro[0] &&
                selectedMetro[0].cities[0] &&
                selectedMetro[0].cities[0].stateQMIDefaultSort) ||
              '';
          } else {
            metroQMIDefaultSort =
              (selectedMetro[0] && selectedMetro[0].metroQMIDefaultSort) || '';
          }
        } else
          metroQMIDefaultSort =
            (selectedMetro && selectedMetro.metroQMIDefaultSort) || '';

        const defaultSort =
          metroQMIDefaultSort === 'Alphabetical'
            ? 'title'
            : metroQMIDefaultSort === 'Price'
            ? 'price'
            : 'date';
        setSort(defaultSort);
      }
    } else setSort('price');
  };

  const handleResetBoundsChange = useCallback(() => {
    resetBoundsRef.current = false;
    setResetBounds(false);
  }, []);

  const handleVisibleItemsChange = useCallback(
    (visibleItems) => {
      // console.log("handleVisibleItemsChange", visibleItems);
      if (isMobile && !showMap) {
        setUseMapViewportFilter(true); //return;
      }

      if (isMobile && resetBoundsRef.current && visibleItems.length < 1) {
        return;
      }

      if (!isMobile || showMap) {
        setUseMapViewportFilter(true);
      }
      setMapReported(true);
      setVisibleInMapIds(visibleItems);
    },
    [isMobile, showMap],
  );

  const handleFilterChange = (key, value, selectAll = false) => {
    switch (key) {
      case 'price':
        setPriceFilter(value);
        break;
      case 'size':
        setSizeFilter(value);
        break;
      case 'cities':
        setCitiesFilter(value);
        break;
      case 'amenities':
        setAmenitiesFilter(value);
        break;
      case 'lotSize':
        setLotSizeFilter(value);
        break;
      case 'productLine':
        setProductLineFilter(value);
        break;
      case 'communityStyles':
        setCommunityStylesFilter(value);
        break;
      case 'bedrooms':
        if (selectAll) {
          setBedroomsFilter([]);
        } else {
          const newBedrooms = [...bedroomsFilter];
          const bedroomValueIndex = newBedrooms.findIndex((e) => e === value);
          if (bedroomValueIndex >= 0) {
            newBedrooms.splice(bedroomValueIndex, 1);
          } else {
            newBedrooms.push(value);
          }
          setBedroomsFilter(newBedrooms);
        }
        break;
      case 'bathrooms':
        if (selectAll) {
          setBathroomsFilter([]);
        } else {
          const newBathrooms = [...bathroomsFilter];
          const bathroomValueIndex = newBathrooms.findIndex((e) => e === value);
          if (bathroomValueIndex >= 0) {
            newBathrooms.splice(bathroomValueIndex, 1);
          } else {
            newBathrooms.push(value);
          }
          setBathroomsFilter(newBathrooms);
        }
        break;
      case 'stories':
        setStoriesFilter(value);
        break;
      case 'garages':
        setGaragesFilter(value);
        break;
      default:
    }
  };

  const onRVSelectedChange = () => {
    setIsRVSelected(!isRVSelected);
  };

  const handleSelectItem = useCallback(
    (item) => {
      if (item && item.id === selectedProduct) {
        setSelectedProduct();
        setShowMobileCard(false);
      } else {
        if (item) {
          setSelectedProduct(item.id);
          setShowMobileCard(true);
          if (!['plan', 'qmi'].includes(productType)) {
            const e = document.getElementById(item.id);
            if (e) {
              e.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
                inline: 'start',
              });
            }
          }
        }
      }
    },
    [selectedProduct],
  );

  useEffect(() => {
    if (selectedProduct) {
      const communitySelected =
        visibleInMapIds && visibleInMapIds.find((e) => e === selectedProduct);
      if (!communitySelected) {
        setSelectedProduct();
        setShowMobileCard(false);
        if (!['plan', 'qmi'].includes(productType)) {
          const e = document.getElementById('SearchResultList');
          if (e) {
            // console.log("visibleInMapIds, selectedProduct");
            e.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
              inline: 'start',
            });
          }
        }
      }
    } else {
      if (visibleInMapIds) {
        const e = document.getElementById('SearchResultList');
        if (e) {
          // console.log("visibleInMapIds, selectedProduct");
          e.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
            inline: 'start',
          });
        } else {
          const e = document.getElementById('SearchNoResults');
          if (e) {
            e.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
              inline: 'start',
            });
          }
        }
      }
    }
  }, [visibleInMapIds, selectedProduct]);

  useEffect(() => {
    if (!isMobile) {
      if (showMap) {
        setMapMounted(true);
      } else {
        setTimeout(() => {
          setMapMounted(false);
        }, 500);
      }
    }
    // isMobile only resolves after mount (SSR renders the 'xs' breakpoint),
    // so it must be a dependency here or desktop keeps the mobile behaviour.
  }, [showMap, isMobile]);

  const [minimumZoom, setMinimumZoom] = useState(null);

  const getSelectedMetroMinimumZoom = () => {
    if (selectedMetro && selectedMetro.length > 0) {
      return (selectedMetro[0] && selectedMetro[0].zoomMin) || null;
    }

    return null;
  };

  const handleToggleMap = () => {
    const nextShowMap = !showMap;

    if (isMobile && nextShowMap && !useMapViewportFilter) {
      resetBoundsRef.current = true;
      setResetBounds(true);
      setMinimumZoom(getSelectedMetroMinimumZoom());
    }

    setShowMap(nextShowMap);
    setHideMap(!nextShowMap);
  };
  const originCommunitiesCards = getFieldValue(fields, 'communityCards') || [];
  const isDesktopHiddenMap = !isMobile && hideMap;
  const useDesktopHiddenMapAreaPins =
    isDesktopHiddenMap && selectedMetro && selectedMetro.length > 1;
  const desktopHiddenMapAreaPins = useMemo(
    () => getSelectedMetroAreaMapPins(originCommunitiesCards, selectedMetro),
    [originCommunitiesCards, selectedMetro],
  );
  const effectiveVisibleInMapIds = useDesktopHiddenMapAreaPins
    ? desktopHiddenMapAreaPins
    : visibleInMapIds;
  const getResetVisibleIds = () => {
    return originCommunitiesCards.map((item) => item.id);
  };
  const maximumZoom = getFieldValue(fields, 'maximumZoom') || [];
  useEffect(() => {
    if (selectedMetro && selectedMetro.length > 0) {
      if (selectedMetro[0] && selectedMetro[0].zoomMin)
        setMinimumZoom(selectedMetro[0].zoomMin);
      else setMinimumZoom(null);
    }
  }, [selectedMetro]);
  const cardsResult = useMemo(
    () =>
      filterByVisibilityInMap(
        filteredCards,
        effectiveVisibleInMapIds,
        showMap || useDesktopHiddenMapAreaPins,
        isMobile,
        useMapViewportFilter,
      ),
    [
      filteredCards,
      effectiveVisibleInMapIds,
      showMap,
      useDesktopHiddenMapAreaPins,
      isMobile,
      useMapViewportFilter,
    ],
  );

  // Home types offered by the Type filter: the ones that exist in the
  // communities currently in the map viewport (mobile behaves as if the map
  // were always present), or in the selected metro/state when the map is hidden.
  // The homeType filter itself is ignored so multiple types can be selected.
  const isHomeTypeScopedByMap = isMobile ? useMapViewportFilter : showMap;
  const getCardsForHomeTypes = (filtersWithoutHomeType, baseShowMap, hidden) =>
    productType === searchProductTypes.COMMUNITY
      ? filterCommunities(
          Object.values(populatedCommunities),
          ...filtersWithoutHomeType,
          baseShowMap,
          hidden,
        )
      : filterCards(
          populatedCommunities,
          productType,
          ...filtersWithoutHomeType,
          baseShowMap,
          hidden,
        );

  const { availableHomeTypes, hasNoPinsInMap } = useMemo(() => {
    const filtersWithoutHomeType = filters.map((f, i) =>
      i === 3 ? ['All'] : f,
    );
    let scopedCards;
    let noPins = false;

    if (isHomeTypeScopedByMap) {
      scopedCards = getCardsForHomeTypes(
        filtersWithoutHomeType,
        true,
        false,
      ).filter(
        (item) =>
          visibleInMapIds.includes(item.id) ||
          visibleInMapIds.includes(item.idCommunity) ||
          visibleInMapIds.includes(item.idMpc),
      );
      if (scopedCards.length < 1) {
        // No pins in the map: offer every type of the selected metro(s)/state
        noPins = true;
        scopedCards = getCardsForHomeTypes(filtersWithoutHomeType, false, true);
      }
    } else {
      scopedCards = getCardsForHomeTypes(
        filtersWithoutHomeType,
        showMap,
        !isMobile && hideMap,
      );
    }

    const types = new Set();
    const addTypes = (value) =>
      (value || '')
        .replace(/\s/g, '')
        .split(',')
        .filter(Boolean)
        .forEach((t) => types.add(t));
    scopedCards.forEach((card) => {
      if (card.type === 'Plan' || card.type === 'QMI') {
        addTypes(card.homeType);
      } else if (
        (card.plans && card.plans.length) ||
        (card.qmi && card.qmi.length)
      ) {
        (card.plans || []).forEach((p) => addTypes(p.homeType));
        (card.qmi || []).forEach((q) => addTypes(q.homeType));
      } else {
        addTypes(card.homeType);
      }
    });
    return { availableHomeTypes: Array.from(types), hasNoPinsInMap: noPins };
  }, [
    productType,
    selectedCommunity,
    priceFilter,
    bedroomsFilter,
    sizeFilter,
    populatedCommunities,
    citiesFilter,
    amenitiesFilter,
    bathroomsFilter,
    garagesFilter,
    lotSizeFilter,
    productLineFilter,
    storiesFilter,
    communityStylesFilter,
    hasDen,
    selectedMetro,
    showMap,
    hideMap,
    isMobile,
    isRVSelected,
    visibleInMapIds,
    isHomeTypeScopedByMap,
  ]);

  const availableOptionsWithHomeTypes = useMemo(
    () => ({ ...availableOptions, homeTypes: availableHomeTypes }),
    [availableOptions, availableHomeTypes],
  );

  // Deselect the home types that are no longer available in the map; with no pins in the map the selection goes back to "All".
  useEffect(() => {
    if (
      !isHomeTypeScopedByMap ||
      !mapReported ||
      !homeType ||
      homeType[0] === 'All'
    ) {
      return;
    }
    if (hasNoPinsInMap) {
      setHomeType(['All']);
      return;
    }
    const stillAvailable = homeType.filter((t) =>
      availableHomeTypes.includes(t.replace(/\s/g, '')),
    );
    if (stillAvailable.length !== homeType.length) {
      setHomeType(stillAvailable.length > 0 ? stillAvailable : ['All']);
    }
  }, [
    availableHomeTypes,
    hasNoPinsInMap,
    isHomeTypeScopedByMap,
    mapReported,
    homeType,
  ]);

  const clearFilters = useCallback(() => {
    // console.log("clearFilters");
    setPriceFilter();
    setSizeFilter();
    setHomeType(['All']);
    // console.log(productType, "clearFilters community");
    setProductType(searchProductTypes.COMMUNITY);
    if (productType === searchProductTypes.COMMUNITY) {
      let metroCommunityDefaultSort = '';
      const isState =
        selectedMetro &&
        selectedMetro[0] &&
        selectedMetro[0].name.toLowerCase() ===
          selectedMetro[0].state.toLowerCase();
      if (selectedMetro && selectedMetro.length > 0) {
        if (isState) {
          metroCommunityDefaultSort =
            (selectedMetro[0] &&
              selectedMetro[0].cities[0] &&
              selectedMetro[0].cities[0].stateCommunityDefaultSort) ||
            '';
        } else {
          metroCommunityDefaultSort =
            (selectedMetro[0] && selectedMetro[0].metroCommunityDefaultSort) ||
            '';
        }
      } else {
        metroCommunityDefaultSort =
          (selectedMetro && selectedMetro.metroCommunityDefaultSort) || '';
      }
      //console.log({ selectedMetro, metroCommunityDefaultSort });
      const defaultSort =
        metroCommunityDefaultSort === 'Alphabetical'
          ? 'title'
          : metroCommunityDefaultSort === 'Price'
          ? 'price'
          : metroCommunityDefaultSort === 'Custom'
          ? 'custom'
          : 'availability';
      setSort(defaultSort);
      if (defaultSort === 'custom') setHasCustomSortFeatured(true);
      else setHasCustomSortFeatured(false);
    } else if (productType === searchProductTypes.QMI) {
      console.log({ selectedMetro });
      let metroQMIDefaultSort = '';
      const isState =
        selectedMetro &&
        selectedMetro[0] &&
        selectedMetro[0].name.toLowerCase() ===
          selectedMetro[0].state.toLowerCase();
      if (selectedMetro && selectedMetro.length > 0) {
        if (isState) {
          metroQMIDefaultSort =
            (selectedMetro[0] &&
              selectedMetro[0].cities[0] &&
              selectedMetro[0].cities[0].stateQMIDefaultSort) ||
            '';
        } else {
          metroQMIDefaultSort =
            (selectedMetro[0] && selectedMetro[0].metroQMIDefaultSort) || '';
        }
      } else metroQMIDefaultSort = selectedMetro.metroQMIDefaultSort || '';

      const defaultSort =
        metroQMIDefaultSort === 'Alphabetical'
          ? 'title'
          : metroQMIDefaultSort === 'Price'
          ? 'price'
          : 'date';
      setSort(defaultSort);
    } else setSort('price');

    setSelectedCommunity([{ id: null, title: 'All' }]);
    setInitialCommunities();
    resetBoundsRef.current = true;
    setResetBounds(true);
    if (isMobile) {
      setMinimumZoom(getSelectedMetroMinimumZoom());
    }
    const resetVisibleIds = isMobile ? getResetVisibleIds() : [];
    setUseMapViewportFilter(false);
    setVisibleInMapIds(resetVisibleIds);
    setBathroomsFilter([]);
    setBedroomsFilter([]);

    const currentParams = queryString.parse(location.search);
    const { community, city, productLine, ...rest } = currentParams;

    // console.log({rest});
    navigate({
      pathname: location.pathname,
      search: '?' + new URLSearchParams(rest).toString(),
    });

    clearMoreFilters();
  }, [
    fields,
    country,
    hasDen,
    selectedMetro,
    productType,
    isMobile,
    originCommunitiesCards,
    location.pathname,
    location.search,
    navigate,
  ]);

  const clearPriceFilters = () => {
    setPriceFilter();
  };

  const clearBedroomsFilter = () => {
    setBedroomsFilter([]);
  };
  const clearBathroomsFilter = () => {
    setBathroomsFilter([]);
  };
  const clearHomeType = () => {
    setHomeType(['All']);
  };

  const clearMoreFilters = () => {
    setCitiesFilter();
    setLotSizeFilter();
    setSizeFilter();
    setAmenitiesFilter();
    setCommunityStylesFilter();
    setProductLineFilter();
    setGaragesFilter([]);
    setStoriesFilter([]);
    setIsRVSelected(false);
  };

  const mapSlide = useSpring({
    right: cardsResult && cardsResult.length !== 0 && showMap ? '0%' : '-100%',
  });

  const moreFiltersNumber = getMoreFiltersNumber(
    citiesFilter,
    amenitiesFilter,
    garagesFilter,
    lotSizeFilter,
    productLineFilter,
    storiesFilter,
    communityStylesFilter,
  );

  let communitiesMap = useMemo(
    () =>
      filterCommunities(
        Object.values(populatedCommunities),
        ...filters,
        showMap,
        isDesktopHiddenMap,
      ),
    [
      selectedCommunity,
      priceFilter,
      bedroomsFilter,
      sizeFilter,
      homeType,
      populatedCommunities,
      citiesFilter,
      amenitiesFilter,
      bathroomsFilter,
      garagesFilter,
      lotSizeFilter,
      productLineFilter,
      storiesFilter,
      resetBounds,
      communityStylesFilter,
      hasDen,
      selectedMetro,
      showMap,
      hideMap,
      isMobile,
      isRVSelected,
    ],
  );

  useEffect(() => {
    // console.log({ selectedMetro });
    if (
      promotionBannerValues &&
      selectedMetro &&
      selectedMetro[0] &&
      promotionBannerValues.length > 0
    ) {
      const newPromoFields = promotionBannerValues.find(
        (e) => e.market.toLowerCase() === selectedMetro[0].name.toLowerCase(),
      );
      if (newPromoFields && newPromoFields.promotionBannerVM) {
        setPromoBannerFields(newPromoFields.promotionBannerVM);
        const e = document.getElementsByTagName('body')[0];
        // console.log({ promotionBannerValues, selectedMetro, newPromoFields });
        if (e) {
          // console.log({ newPromoFields });
          setTimeout(() => {
            e.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
              inline: 'start',
            });
          }, 1000);
        }
      } else setPromoBannerFields({});
    }
  }, [promotionBannerValues, selectedMetro, productType]);

  useEffect(() => {
    updateMetroSearchSelectedMetro(
      selectedMetro && selectedMetro[0] ? selectedMetro : null,
    );
  }, [selectedMetro, updateMetroSearchSelectedMetro]);

  useEffect(() => {
    if (isMobile) {
      const notificationBannerDiv = document.getElementById(
        'national-notification-banner',
      );
      if (moreFilters && notificationBannerDiv)
        notificationBannerDiv.classList.add('hidden');
      else if (notificationBannerDiv)
        notificationBannerDiv.classList.remove('hidden');
    }
    // isMobile only resolves after mount (SSR renders the 'xs' breakpoint),
    // so it must be a dependency here or desktop keeps the mobile behaviour.
  }, [moreFilters, isMobile]);

  const getAttributeRanges = (attributes, icon) => {
    const attrCard =
      attributes &&
      attributes.find((a) => a.icon === icon) &&
      attributes.find((a) => a.icon === icon).label;

    const splitAttrs = attrCard && attrCard.split(' ');
    let digitsAttrs = [];
    for (let i = 0; i < splitAttrs.length; i++) {
      const digit = eval(splitAttrs[i].replace(/\D/g, ''));
      if (typeof digit !== 'undefined') digitsAttrs.push(digit);
    }
    return {
      minRange: digitsAttrs.length > 0 && digitsAttrs[0],
      maxRange: (digitsAttrs.length > 1 && digitsAttrs[1]) || digitsAttrs[0],
    };
  };

  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let availableHomeTypes = []; //
    let minPrice = -1; //
    let maxPrice = -1; //
    /* for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].type === "Plan" || filteredCards[i].type === "QMI") {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, "")));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, "").split(",")) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, "") === homeTypesCard[j]
          );
          if (typeof homeTypec === "undefined") {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, "")));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }

            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, "").split(",")) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, "") === homeTypesCard[j]
              );
              if (typeof homeTypec === "undefined") {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, "")));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, "").split(",")) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, "") === homeTypesCard[j]
              );
              if (typeof homeTypec === "undefined") {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
      }
    }*/
    // console.log({ filteredCards, availableOptions });

    setAvailableOptions({
      price: {
        minPrice: availableOptions.price && availableOptions.price.minPrice,
        maxPrice: availableOptions.price && availableOptions.price.maxPrice,
      }, //
      // price: { minPrice: minPrice, maxPrice: maxPrice },
      bedsAndBaths: {
        beds:
          availableOptions.bedsAndBaths && availableOptions.bedsAndBaths.beds,
        baths:
          availableOptions.bedsAndBaths && availableOptions.bedsAndBaths.baths,
      },
      homeTypes: availableOptions.homeTypes, //
      stories: availableOptions.stories, //
      garages: availableOptions.garages, //
      cities: availableOptions.cities, //
      amenities: availableOptions.amenities, //
      communityStyles: availableOptions.communityStyles, //
      sizes: availableOptions.sizes, //
      productLines: availableOptions.productLines, //
      isRVAvailable: availableOptions.isRVAvailable,
    });
  }, [filteredCards]);

  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let minPrice = -1; //
    let maxPrice = -1; //
    let availableBeds = [];
    let availableBaths = []; //
    let availableHomeTypes = []; //
    let availableCities = []; //
    let availableStories = []; //
    let availableGarages = []; //
    let availableAmenities = []; //
    let availableCommunityStyles = []; //
    let availableSizes = []; //
    let availableProductLines = []; //
    let availableRV = false;

    // console.log({ visibleInMapIds, filteredCards });

    for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].city) {
        const cityCard = availableCities.find(
          (e) => e === filteredCards[i].city.replace(/\s/g, ''),
        );
        if (typeof cityCard === 'undefined') {
          availableCities.push(filteredCards[i].city.replace(/\s/g, ''));
        }
      }

      const amenitiesCard =
        (filteredCards[i].amenities &&
          filteredCards[i].amenities.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < amenitiesCard.length; j++) {
        const ammenitie = availableAmenities.find(
          (e) => e.replace(/\s/g, '') === amenitiesCard[j],
        );
        if (typeof ammenitie === 'undefined') {
          availableAmenities.push(amenitiesCard[j]);
        }
      }

      const communityStylesCard =
        (filteredCards[i].communityStyles &&
          filteredCards[i].communityStyles.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < communityStylesCard.length; j++) {
        const communityStyle = availableCommunityStyles.find(
          (e) => e.replace(/\s/g, '') === communityStylesCard[j],
        );
        if (typeof communityStyle === 'undefined') {
          availableCommunityStyles.push(communityStylesCard[j]);
        }
      }

      if (filteredCards[i].type === 'Plan' || filteredCards[i].type === 'QMI') {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, '')));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        if (!availableRV && filteredCards[i].rvGarage) {
          // console.log(filteredCards[i]);
          availableRV = true;
        }

        const lotSizesCard =
          (filteredCards[i].lotSizes &&
            filteredCards[i].lotSizes.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < lotSizesCard.length; j++) {
          const lotSize = availableSizes.find(
            (e) => e.replace(/\s/g, '') === lotSizesCard[j],
          );
          if (typeof lotSize === 'undefined') {
            availableSizes.push(lotSizesCard[j]);
          }
        }

        const productLinesCard =
          (filteredCards[i].productLines &&
            filteredCards[i].productLines.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < productLinesCard.length; j++) {
          const productLine = availableProductLines.find(
            (e) => e.replace(/\s/g, '') === productLinesCard[j],
          );
          if (typeof productLine === 'undefined') {
            availableProductLines.push(productLinesCard[j]);
          }
        }

        const attributes = filteredCards[i].attributes;
        const bedsAttrCard = getAttributeRanges(attributes, 'bed');
        for (
          let b = bedsAttrCard.minRange;
          b < bedsAttrCard.maxRange + 1;
          b++
        ) {
          const bedsCard = availableBeds.find((e) => e === b);
          if (typeof bedsCard === 'undefined') {
            availableBeds.push(b);
          }
        }
        const bathsAttrCard = getAttributeRanges(attributes, 'bath');
        for (
          let b = bathsAttrCard.minRange;
          b < bathsAttrCard.maxRange + 1;
          b++
        ) {
          const bathsCard = availableBaths.find((e) => e === b);
          if (typeof bathsCard === 'undefined') {
            availableBaths.push(b);
          }
        }
        const garagesAttrCard = getAttributeRanges(attributes, 'car');
        for (
          let b = garagesAttrCard.minRange;
          b < garagesAttrCard.maxRange + 1;
          b++
        ) {
          const garageCard = availableGarages.find((e) => e === b);
          if (typeof garageCard === 'undefined') {
            availableGarages.push(b);
          }
        }
        const storiesAttrCard = getAttributeRanges(attributes, 'stories');
        for (
          let b = storiesAttrCard.minRange;
          b < storiesAttrCard.maxRange + 1;
          b++
        ) {
          const storiesCard = availableStories.find((e) => e === b);
          if (typeof storiesCard === 'undefined') {
            availableStories.push(b);
          }
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, '') === homeTypesCard[j],
          );
          if (typeof homeTypec === 'undefined') {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crplans[p].rvGarage) {
              // console.log(crplans[p]);
              availableRV = true;
            }

            const lotSizesCard =
              (crplans[p].lotSizes &&
                crplans[p].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crplans[p].productLines &&
                crplans[p].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crplans[p].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crqmis[q].rvGarage) {
              // console.log(crqmis[q]);
              availableRV = true;
            }

            const lotSizesCard =
              (crqmis[q].lotSizes &&
                crqmis[q].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crqmis[q].productLines &&
                crqmis[q].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crqmis[q].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                // if (b === 3) console.log(filteredCards[i]);
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        // }
      }
    }

    let showAllHomeTypes = true;
    if (bedroomsFilter.length > 0) showAllHomeTypes = false;
    if (bathroomsFilter.length > 0) showAllHomeTypes = false;
    if (storiesFilter.length > 0) showAllHomeTypes = false;
    if (garagesFilter.length > 0) showAllHomeTypes = false;
    if (citiesFilter && citiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (communityStylesFilter && communityStylesFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (lotSizeFilter && lotSizeFilter.length > 0) showAllHomeTypes = false;
    if (productLineFilter && productLineFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (sizeFilter && sizeFilter.length > 0) showAllHomeTypes = false;
    if (
      priceFilter &&
      ((priceFilter.min && priceFilter.min > 0) ||
        (priceFilter.max && priceFilter.max > 0))
    ) {
      showAllHomeTypes = false;
    }

    const homeTypesList = getFieldValue(fields, 'homeTypesList') || [];
    const availableCompleteHomeTypes = [];
    homeTypesList.forEach((ht) => {
      if (typeof ht !== 'undefined' && ht.length > 0) {
        availableCompleteHomeTypes.push(ht.replace(/\s/g, ''));
      }
    });

    // console.log({ availableStories });

    setAvailableOptions({
      price: { minPrice: minPrice, maxPrice: maxPrice }, //
      bedsAndBaths: {
        beds: availableBeds,
        baths: availableBaths,
      }, //
      stories: availableStories, //
      garages: availableGarages, //
      homeTypes: showAllHomeTypes
        ? availableCompleteHomeTypes
        : availableHomeTypes, //
      cities: availableCities, //
      amenities: availableAmenities, //
      communityStyles: availableCommunityStyles, //
      sizes: availableSizes, //
      productLines: availableProductLines, //
      isRVAvailable: availableRV,
    });
  }, [
    storiesFilter,
    garagesFilter,
    amenitiesFilter,
    communityStylesFilter,
    populatedCommunities,
    visibleInMapIds,
    productType,
    selectedCommunity,
    isRVSelected,
    filteredCards,
  ]);

  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let minPrice = -1; //
    let maxPrice = -1; //
    let availableBeds = [];
    let availableBaths = []; //
    let availableHomeTypes = []; //
    let availableCities = []; //
    let availableStories = []; //
    let availableGarages = []; //
    let availableAmenities = []; //
    let availableCommunityStyles = []; //
    let availableSizes = []; //
    let availableProductLines = []; //
    let availableRV = false;

    // console.log({visibleInMapIds, filteredCards, populatedCommunities});

    for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].city) {
        const cityCard = availableCities.find(
          (e) => e === filteredCards[i].city.replace(/\s/g, ''),
        );
        if (typeof cityCard === 'undefined') {
          availableCities.push(filteredCards[i].city.replace(/\s/g, ''));
        }
      }

      const amenitiesCard =
        (filteredCards[i].amenities &&
          filteredCards[i].amenities.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < amenitiesCard.length; j++) {
        const ammenitie = availableAmenities.find(
          (e) => e.replace(/\s/g, '') === amenitiesCard[j],
        );
        if (typeof ammenitie === 'undefined') {
          availableAmenities.push(amenitiesCard[j]);
        }
      }

      const communityStylesCard =
        (filteredCards[i].communityStyles &&
          filteredCards[i].communityStyles.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < communityStylesCard.length; j++) {
        const communityStyle = availableCommunityStyles.find(
          (e) => e.replace(/\s/g, '') === communityStylesCard[j],
        );
        if (typeof communityStyle === 'undefined') {
          availableCommunityStyles.push(communityStylesCard[j]);
        }
      }

      if (filteredCards[i].type === 'Plan' || filteredCards[i].type === 'QMI') {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, '')));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        if (!availableRV && filteredCards[i].rvGarage) {
          // console.log(filteredCards[i]);
          availableRV = true;
        }

        const lotSizesCard =
          (filteredCards[i].lotSizes &&
            filteredCards[i].lotSizes.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < lotSizesCard.length; j++) {
          const lotSize = availableSizes.find(
            (e) => e.replace(/\s/g, '') === lotSizesCard[j],
          );
          if (typeof lotSize === 'undefined') {
            availableSizes.push(lotSizesCard[j]);
          }
        }

        const productLinesCard =
          (filteredCards[i].productLines &&
            filteredCards[i].productLines.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < productLinesCard.length; j++) {
          const productLine = availableProductLines.find(
            (e) => e.replace(/\s/g, '') === productLinesCard[j],
          );
          if (typeof productLine === 'undefined') {
            availableProductLines.push(productLinesCard[j]);
          }
        }

        const attributes = filteredCards[i].attributes;
        const bedsAttrCard = getAttributeRanges(attributes, 'bed');
        for (
          let b = bedsAttrCard.minRange;
          b < bedsAttrCard.maxRange + 1;
          b++
        ) {
          const bedsCard = availableBeds.find((e) => e === b);
          if (typeof bedsCard === 'undefined') {
            availableBeds.push(b);
          }
        }
        const bathsAttrCard = getAttributeRanges(attributes, 'bath');
        for (
          let b = bathsAttrCard.minRange;
          b < bathsAttrCard.maxRange + 1;
          b++
        ) {
          const bathsCard = availableBaths.find((e) => e === b);
          if (typeof bathsCard === 'undefined') {
            availableBaths.push(b);
          }
        }
        const garagesAttrCard = getAttributeRanges(attributes, 'car');
        for (
          let b = garagesAttrCard.minRange;
          b < garagesAttrCard.maxRange + 1;
          b++
        ) {
          const garageCard = availableGarages.find((e) => e === b);
          if (typeof garageCard === 'undefined') {
            availableGarages.push(b);
          }
        }
        const storiesAttrCard = getAttributeRanges(attributes, 'stories');
        for (
          let b = storiesAttrCard.minRange;
          b < storiesAttrCard.maxRange + 1;
          b++
        ) {
          const storiesCard = availableStories.find((e) => e === b);
          if (typeof storiesCard === 'undefined') {
            availableStories.push(b);
          }
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, '') === homeTypesCard[j],
          );
          if (typeof homeTypec === 'undefined') {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crplans[p].rvGarage) {
              // console.log(crplans[p]);
              availableRV = true;
            }

            const lotSizesCard =
              (crplans[p].lotSizes &&
                crplans[p].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crplans[p].productLines &&
                crplans[p].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crplans[p].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crqmis[q].rvGarage) {
              // console.log(crqmis[q]);
              availableRV = true;
            }

            const lotSizesCard =
              (crqmis[q].lotSizes &&
                crqmis[q].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crqmis[q].productLines &&
                crqmis[q].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crqmis[q].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                // if (b === 3) console.log(filteredCards[i]);
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
      }
    }

    let showAllHomeTypes = true;
    if (bedroomsFilter.length > 0) showAllHomeTypes = false;
    if (bathroomsFilter.length > 0) showAllHomeTypes = false;
    if (storiesFilter.length > 0) showAllHomeTypes = false;
    if (garagesFilter.length > 0) showAllHomeTypes = false;
    if (citiesFilter && citiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (communityStylesFilter && communityStylesFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (lotSizeFilter && lotSizeFilter.length > 0) showAllHomeTypes = false;
    if (productLineFilter && productLineFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (sizeFilter && sizeFilter.length > 0) showAllHomeTypes = false;
    if (
      priceFilter &&
      ((priceFilter.min && priceFilter.min > 0) ||
        (priceFilter.max && priceFilter.max > 0))
    ) {
      showAllHomeTypes = false;
    }

    const homeTypesList = getFieldValue(fields, 'homeTypesList') || [];
    const availableCompleteHomeTypes = [];
    homeTypesList.forEach((ht) => {
      if (typeof ht !== 'undefined' && ht.length > 0) {
        availableCompleteHomeTypes.push(ht.replace(/\s/g, ''));
      }
    });

    setAvailableOptions({
      price: { minPrice: minPrice, maxPrice: maxPrice }, //
      bedsAndBaths: {
        beds: availableBeds,
        baths: availableBaths,
      }, //
      stories: availableStories, //
      garages: availableGarages, //
      homeTypes: showAllHomeTypes
        ? availableCompleteHomeTypes
        : availableHomeTypes, //
      cities:
        citiesFilter && citiesFilter.length > 0
          ? availableOptions.cities
          : availableCities, //
      amenities: availableAmenities, //
      communityStyles: availableCommunityStyles, //
      sizes: availableSizes, //
      productLines: availableProductLines, //
      isRVAvailable: availableRV,
    });
  }, [citiesFilter]);
  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let minPrice = -1; //
    let maxPrice = -1; //
    let availableBeds = [];
    let availableBaths = []; //
    let availableHomeTypes = []; //
    let availableCities = []; //
    let availableStories = []; //
    let availableGarages = []; //
    let availableAmenities = []; //
    let availableCommunityStyles = []; //
    let availableSizes = []; //
    let availableProductLines = []; //
    let availableRV = false;

    // console.log({visibleInMapIds, filteredCards, populatedCommunities});

    for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].city) {
        const cityCard = availableCities.find(
          (e) => e === filteredCards[i].city.replace(/\s/g, ''),
        );
        if (typeof cityCard === 'undefined') {
          availableCities.push(filteredCards[i].city.replace(/\s/g, ''));
        }
      }

      const amenitiesCard =
        (filteredCards[i].amenities &&
          filteredCards[i].amenities.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < amenitiesCard.length; j++) {
        const ammenitie = availableAmenities.find(
          (e) => e.replace(/\s/g, '') === amenitiesCard[j],
        );
        if (typeof ammenitie === 'undefined') {
          availableAmenities.push(amenitiesCard[j]);
        }
      }

      const communityStylesCard =
        (filteredCards[i].communityStyles &&
          filteredCards[i].communityStyles.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < communityStylesCard.length; j++) {
        const communityStyle = availableCommunityStyles.find(
          (e) => e.replace(/\s/g, '') === communityStylesCard[j],
        );
        if (typeof communityStyle === 'undefined') {
          availableCommunityStyles.push(communityStylesCard[j]);
        }
      }

      if (filteredCards[i].type === 'Plan' || filteredCards[i].type === 'QMI') {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, '')));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        if (!availableRV && filteredCards[i].rvGarage) {
          // console.log(filteredCards[i]);
          availableRV = true;
        }

        const lotSizesCard =
          (filteredCards[i].lotSizes &&
            filteredCards[i].lotSizes.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < lotSizesCard.length; j++) {
          const lotSize = availableSizes.find(
            (e) => e.replace(/\s/g, '') === lotSizesCard[j],
          );
          if (typeof lotSize === 'undefined') {
            availableSizes.push(lotSizesCard[j]);
          }
        }

        const productLinesCard =
          (filteredCards[i].productLines &&
            filteredCards[i].productLines.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < productLinesCard.length; j++) {
          const productLine = availableProductLines.find(
            (e) => e.replace(/\s/g, '') === productLinesCard[j],
          );
          if (typeof productLine === 'undefined') {
            availableProductLines.push(productLinesCard[j]);
          }
        }

        const attributes = filteredCards[i].attributes;
        const bedsAttrCard = getAttributeRanges(attributes, 'bed');
        for (
          let b = bedsAttrCard.minRange;
          b < bedsAttrCard.maxRange + 1;
          b++
        ) {
          const bedsCard = availableBeds.find((e) => e === b);
          if (typeof bedsCard === 'undefined') {
            availableBeds.push(b);
          }
        }
        const bathsAttrCard = getAttributeRanges(attributes, 'bath');
        for (
          let b = bathsAttrCard.minRange;
          b < bathsAttrCard.maxRange + 1;
          b++
        ) {
          const bathsCard = availableBaths.find((e) => e === b);
          if (typeof bathsCard === 'undefined') {
            availableBaths.push(b);
          }
        }
        const garagesAttrCard = getAttributeRanges(attributes, 'car');
        for (
          let b = garagesAttrCard.minRange;
          b < garagesAttrCard.maxRange + 1;
          b++
        ) {
          const garageCard = availableGarages.find((e) => e === b);
          if (typeof garageCard === 'undefined') {
            availableGarages.push(b);
          }
        }
        const storiesAttrCard = getAttributeRanges(attributes, 'stories');
        for (
          let b = storiesAttrCard.minRange;
          b < storiesAttrCard.maxRange + 1;
          b++
        ) {
          const storiesCard = availableStories.find((e) => e === b);
          if (typeof storiesCard === 'undefined') {
            availableStories.push(b);
          }
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, '') === homeTypesCard[j],
          );
          if (typeof homeTypec === 'undefined') {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crplans[p].rvGarage) {
              // console.log(crplans[p]);
              availableRV = true;
            }

            const lotSizesCard =
              (crplans[p].lotSizes &&
                crplans[p].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crplans[p].productLines &&
                crplans[p].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crplans[p].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crqmis[q].rvGarage) {
              // console.log(crqmis[q]);
              availableRV = true;
            }

            const lotSizesCard =
              (crqmis[q].lotSizes &&
                crqmis[q].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crqmis[q].productLines &&
                crqmis[q].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crqmis[q].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                // if (b === 3) console.log(filteredCards[i]);
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
      }
    }

    let showAllHomeTypes = true;
    if (bedroomsFilter.length > 0) showAllHomeTypes = false;
    if (bathroomsFilter.length > 0) showAllHomeTypes = false;
    if (storiesFilter.length > 0) showAllHomeTypes = false;
    if (garagesFilter.length > 0) showAllHomeTypes = false;
    if (citiesFilter && citiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (communityStylesFilter && communityStylesFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (lotSizeFilter && lotSizeFilter.length > 0) showAllHomeTypes = false;
    if (productLineFilter && productLineFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (sizeFilter && sizeFilter.length > 0) showAllHomeTypes = false;
    if (
      priceFilter &&
      ((priceFilter.min && priceFilter.min > 0) ||
        (priceFilter.max && priceFilter.max > 0))
    ) {
      showAllHomeTypes = false;
    }

    const homeTypesList = getFieldValue(fields, 'homeTypesList') || [];
    const availableCompleteHomeTypes = [];
    homeTypesList.forEach((ht) => {
      if (typeof ht !== 'undefined' && ht.length > 0) {
        availableCompleteHomeTypes.push(ht.replace(/\s/g, ''));
      }
    });

    setAvailableOptions({
      price: { minPrice: minPrice, maxPrice: maxPrice }, //
      bedsAndBaths: {
        beds: availableBeds,
        baths: availableBaths,
      }, //
      stories: availableStories, //
      garages: availableGarages, //
      homeTypes: showAllHomeTypes
        ? availableCompleteHomeTypes
        : availableHomeTypes, //
      cities: availableCities, //
      amenities: availableAmenities, //
      communityStyles: availableCommunityStyles, //
      sizes: availableSizes, //
      productLines:
        productLineFilter && productLineFilter.length > 0
          ? availableOptions.productLines
          : availableProductLines, //
      isRVAvailable: availableRV,
    });
  }, [productLineFilter]);
  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let minPrice = -1; //
    let maxPrice = -1; //
    let availableBeds = [];
    let availableBaths = []; //
    let availableHomeTypes = []; //
    let availableCities = []; //
    let availableStories = []; //
    let availableGarages = []; //
    let availableAmenities = []; //
    let availableCommunityStyles = []; //
    let availableSizes = []; //
    let availableProductLines = []; //
    let availableRV = false;

    // console.log({visibleInMapIds, filteredCards, populatedCommunities});

    for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].city) {
        const cityCard = availableCities.find(
          (e) => e === filteredCards[i].city.replace(/\s/g, ''),
        );
        if (typeof cityCard === 'undefined') {
          availableCities.push(filteredCards[i].city.replace(/\s/g, ''));
        }
      }

      const amenitiesCard =
        (filteredCards[i].amenities &&
          filteredCards[i].amenities.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < amenitiesCard.length; j++) {
        const ammenitie = availableAmenities.find(
          (e) => e.replace(/\s/g, '') === amenitiesCard[j],
        );
        if (typeof ammenitie === 'undefined') {
          availableAmenities.push(amenitiesCard[j]);
        }
      }

      const communityStylesCard =
        (filteredCards[i].communityStyles &&
          filteredCards[i].communityStyles.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < communityStylesCard.length; j++) {
        const communityStyle = availableCommunityStyles.find(
          (e) => e.replace(/\s/g, '') === communityStylesCard[j],
        );
        if (typeof communityStyle === 'undefined') {
          availableCommunityStyles.push(communityStylesCard[j]);
        }
      }

      if (filteredCards[i].type === 'Plan' || filteredCards[i].type === 'QMI') {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, '')));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        if (!availableRV && filteredCards[i].rvGarage) {
          // console.log(filteredCards[i]);
          availableRV = true;
        }

        const lotSizesCard =
          (filteredCards[i].lotSizes &&
            filteredCards[i].lotSizes.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < lotSizesCard.length; j++) {
          const lotSize = availableSizes.find(
            (e) => e.replace(/\s/g, '') === lotSizesCard[j],
          );
          if (typeof lotSize === 'undefined') {
            availableSizes.push(lotSizesCard[j]);
          }
        }

        const productLinesCard =
          (filteredCards[i].productLines &&
            filteredCards[i].productLines.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < productLinesCard.length; j++) {
          const productLine = availableProductLines.find(
            (e) => e.replace(/\s/g, '') === productLinesCard[j],
          );
          if (typeof productLine === 'undefined') {
            availableProductLines.push(productLinesCard[j]);
          }
        }

        const attributes = filteredCards[i].attributes;
        const bedsAttrCard = getAttributeRanges(attributes, 'bed');
        for (
          let b = bedsAttrCard.minRange;
          b < bedsAttrCard.maxRange + 1;
          b++
        ) {
          const bedsCard = availableBeds.find((e) => e === b);
          if (typeof bedsCard === 'undefined') {
            availableBeds.push(b);
          }
        }
        const bathsAttrCard = getAttributeRanges(attributes, 'bath');
        for (
          let b = bathsAttrCard.minRange;
          b < bathsAttrCard.maxRange + 1;
          b++
        ) {
          const bathsCard = availableBaths.find((e) => e === b);
          if (typeof bathsCard === 'undefined') {
            availableBaths.push(b);
          }
        }
        const garagesAttrCard = getAttributeRanges(attributes, 'car');
        for (
          let b = garagesAttrCard.minRange;
          b < garagesAttrCard.maxRange + 1;
          b++
        ) {
          const garageCard = availableGarages.find((e) => e === b);
          if (typeof garageCard === 'undefined') {
            availableGarages.push(b);
          }
        }
        const storiesAttrCard = getAttributeRanges(attributes, 'stories');
        for (
          let b = storiesAttrCard.minRange;
          b < storiesAttrCard.maxRange + 1;
          b++
        ) {
          const storiesCard = availableStories.find((e) => e === b);
          if (typeof storiesCard === 'undefined') {
            availableStories.push(b);
          }
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, '') === homeTypesCard[j],
          );
          if (typeof homeTypec === 'undefined') {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crplans[p].rvGarage) {
              // console.log(crplans[p]);
              availableRV = true;
            }

            const lotSizesCard =
              (crplans[p].lotSizes &&
                crplans[p].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crplans[p].productLines &&
                crplans[p].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crplans[p].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crqmis[q].rvGarage) {
              // console.log(crqmis[q]);
              availableRV = true;
            }

            const lotSizesCard =
              (crqmis[q].lotSizes &&
                crqmis[q].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crqmis[q].productLines &&
                crqmis[q].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crqmis[q].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                // if (b === 3) console.log(filteredCards[i]);
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
      }
    }

    let showAllHomeTypes = true;
    if (bedroomsFilter.length > 0) showAllHomeTypes = false;
    if (bathroomsFilter.length > 0) showAllHomeTypes = false;
    if (storiesFilter.length > 0) showAllHomeTypes = false;
    if (garagesFilter.length > 0) showAllHomeTypes = false;
    if (citiesFilter && citiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (communityStylesFilter && communityStylesFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (lotSizeFilter && lotSizeFilter.length > 0) showAllHomeTypes = false;
    if (productLineFilter && productLineFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (sizeFilter && sizeFilter.length > 0) showAllHomeTypes = false;
    if (
      priceFilter &&
      ((priceFilter.min && priceFilter.min > 0) ||
        (priceFilter.max && priceFilter.max > 0))
    ) {
      showAllHomeTypes = false;
    }

    const homeTypesList = getFieldValue(fields, 'homeTypesList') || [];
    const availableCompleteHomeTypes = [];
    homeTypesList.forEach((ht) => {
      if (typeof ht !== 'undefined' && ht.length > 0) {
        availableCompleteHomeTypes.push(ht.replace(/\s/g, ''));
      }
    });

    setAvailableOptions({
      price: { minPrice: minPrice, maxPrice: maxPrice }, //
      bedsAndBaths: {
        beds: availableBeds,
        baths: availableBaths,
      }, //
      stories: availableStories, //
      garages: availableGarages, //
      homeTypes: showAllHomeTypes
        ? availableCompleteHomeTypes
        : availableHomeTypes, //
      cities: availableCities, //
      amenities: availableAmenities, //
      communityStyles: availableCommunityStyles, //
      // sizes: availableOptions.sizes, //
      sizes:
        lotSizeFilter && lotSizeFilter.length > 0
          ? availableOptions.sizes
          : availableSizes, //
      productLines: availableProductLines, //
      isRVAvailable: availableRV,
    });
  }, [lotSizeFilter]);
  useEffect(() => {
    // console.log({communitiesMap, populatedCommunities, filteredCards, cardsResult})
    let minPrice = -1; //
    let maxPrice = -1; //
    let availableBeds = [];
    let availableBaths = []; //
    let availableHomeTypes = []; //
    let availableCities = []; //
    let availableStories = []; //
    let availableGarages = []; //
    let availableAmenities = []; //
    let availableCommunityStyles = []; //
    let availableSizes = []; //
    let availableProductLines = []; //
    let availableRV = false;

    // console.log({visibleInMapIds, filteredCards, populatedCommunities});

    for (let i = 0; i < filteredCards.length; i++) {
      if (filteredCards[i].city) {
        const cityCard = availableCities.find(
          (e) => e === filteredCards[i].city.replace(/\s/g, ''),
        );
        if (typeof cityCard === 'undefined') {
          availableCities.push(filteredCards[i].city.replace(/\s/g, ''));
        }
      }

      const amenitiesCard =
        (filteredCards[i].amenities &&
          filteredCards[i].amenities.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < amenitiesCard.length; j++) {
        const ammenitie = availableAmenities.find(
          (e) => e.replace(/\s/g, '') === amenitiesCard[j],
        );
        if (typeof ammenitie === 'undefined') {
          availableAmenities.push(amenitiesCard[j]);
        }
      }

      const communityStylesCard =
        (filteredCards[i].communityStyles &&
          filteredCards[i].communityStyles.replace(/\s/g, '').split(',')) ||
        [];
      for (let j = 0; j < communityStylesCard.length; j++) {
        const communityStyle = availableCommunityStyles.find(
          (e) => e.replace(/\s/g, '') === communityStylesCard[j],
        );
        if (typeof communityStyle === 'undefined') {
          availableCommunityStyles.push(communityStylesCard[j]);
        }
      }

      if (filteredCards[i].type === 'Plan' || filteredCards[i].type === 'QMI') {
        const priceCard =
          filteredCards[i].price &&
          parseFloat(eval(filteredCards[i].price.price.replace(/\D/g, '')));
        if (minPrice === -1 || priceCard < minPrice) {
          minPrice = priceCard;
        }
        if (maxPrice === -1 || priceCard > maxPrice) {
          maxPrice = priceCard;
        }
        if (!availableRV && filteredCards[i].rvGarage) {
          // console.log(filteredCards[i]);
          availableRV = true;
        }

        const lotSizesCard =
          (filteredCards[i].lotSizes &&
            filteredCards[i].lotSizes.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < lotSizesCard.length; j++) {
          const lotSize = availableSizes.find(
            (e) => e.replace(/\s/g, '') === lotSizesCard[j],
          );
          if (typeof lotSize === 'undefined') {
            availableSizes.push(lotSizesCard[j]);
          }
        }

        const productLinesCard =
          (filteredCards[i].productLines &&
            filteredCards[i].productLines.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < productLinesCard.length; j++) {
          const productLine = availableProductLines.find(
            (e) => e.replace(/\s/g, '') === productLinesCard[j],
          );
          if (typeof productLine === 'undefined') {
            availableProductLines.push(productLinesCard[j]);
          }
        }

        const attributes = filteredCards[i].attributes;
        const bedsAttrCard = getAttributeRanges(attributes, 'bed');
        for (
          let b = bedsAttrCard.minRange;
          b < bedsAttrCard.maxRange + 1;
          b++
        ) {
          const bedsCard = availableBeds.find((e) => e === b);
          if (typeof bedsCard === 'undefined') {
            availableBeds.push(b);
          }
        }
        const bathsAttrCard = getAttributeRanges(attributes, 'bath');
        for (
          let b = bathsAttrCard.minRange;
          b < bathsAttrCard.maxRange + 1;
          b++
        ) {
          const bathsCard = availableBaths.find((e) => e === b);
          if (typeof bathsCard === 'undefined') {
            availableBaths.push(b);
          }
        }
        const garagesAttrCard = getAttributeRanges(attributes, 'car');
        for (
          let b = garagesAttrCard.minRange;
          b < garagesAttrCard.maxRange + 1;
          b++
        ) {
          const garageCard = availableGarages.find((e) => e === b);
          if (typeof garageCard === 'undefined') {
            availableGarages.push(b);
          }
        }
        const storiesAttrCard = getAttributeRanges(attributes, 'stories');
        for (
          let b = storiesAttrCard.minRange;
          b < storiesAttrCard.maxRange + 1;
          b++
        ) {
          const storiesCard = availableStories.find((e) => e === b);
          if (typeof storiesCard === 'undefined') {
            availableStories.push(b);
          }
        }
        const homeTypesCard =
          (filteredCards[i].homeType &&
            filteredCards[i].homeType.replace(/\s/g, '').split(',')) ||
          [];
        for (let j = 0; j < homeTypesCard.length; j++) {
          const homeTypec = availableHomeTypes.find(
            (e) => e.replace(/\s/g, '') === homeTypesCard[j],
          );
          if (typeof homeTypec === 'undefined') {
            availableHomeTypes.push(homeTypesCard[j]);
          }
        }
      } else {
        const crplans = filteredCards[i].plans;
        const crqmis = filteredCards[i].qmi;
        if (crplans && crplans.length > 0) {
          for (let p = 0; p < crplans.length; p++) {
            const priceCard =
              crplans[p].price &&
              parseFloat(eval(crplans[p].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crplans[p].rvGarage) {
              // console.log(crplans[p]);
              availableRV = true;
            }

            const lotSizesCard =
              (crplans[p].lotSizes &&
                crplans[p].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crplans[p].productLines &&
                crplans[p].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crplans[p].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crplans[p].homeType &&
                crplans[p].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
        if (crqmis && crqmis.length > 0) {
          for (let q = 0; q < crqmis.length; q++) {
            const priceCard =
              crqmis[q].price &&
              parseFloat(eval(crqmis[q].price.price.replace(/\D/g, '')));
            if (minPrice === -1 || priceCard < minPrice) {
              minPrice = priceCard;
            }
            if (maxPrice === -1 || priceCard > maxPrice) {
              maxPrice = priceCard;
            }
            if (!availableRV && crqmis[q].rvGarage) {
              // console.log(crqmis[q]);
              availableRV = true;
            }

            const lotSizesCard =
              (crqmis[q].lotSizes &&
                crqmis[q].lotSizes.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < lotSizesCard.length; j++) {
              const lotSize = availableSizes.find(
                (e) => e.replace(/\s/g, '') === lotSizesCard[j],
              );
              if (typeof lotSize === 'undefined') {
                availableSizes.push(lotSizesCard[j]);
              }
            }

            const productLinesCard =
              (crqmis[q].productLines &&
                crqmis[q].productLines.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < productLinesCard.length; j++) {
              const productLine = availableProductLines.find(
                (e) => e.replace(/\s/g, '') === productLinesCard[j],
              );
              if (typeof productLine === 'undefined') {
                availableProductLines.push(productLinesCard[j]);
              }
            }

            const attributes = crqmis[q].attributes;
            const bedsAttrCard = getAttributeRanges(attributes, 'bed');
            for (
              let b = bedsAttrCard.minRange;
              b < bedsAttrCard.maxRange + 1;
              b++
            ) {
              const bedsCard = availableBeds.find((e) => e === b);
              if (typeof bedsCard === 'undefined') {
                // if (b === 3) console.log(filteredCards[i]);
                availableBeds.push(b);
              }
            }
            const bathsAttrCard = getAttributeRanges(attributes, 'bath');
            for (
              let b = bathsAttrCard.minRange;
              b < bathsAttrCard.maxRange + 1;
              b++
            ) {
              const bathsCard = availableBaths.find((e) => e === b);
              if (typeof bathsCard === 'undefined') {
                availableBaths.push(b);
              }
            }
            const garagesAttrCard = getAttributeRanges(attributes, 'car');
            for (
              let b = garagesAttrCard.minRange;
              b < garagesAttrCard.maxRange + 1;
              b++
            ) {
              const garageCard = availableGarages.find((e) => e === b);
              if (typeof garageCard === 'undefined') {
                availableGarages.push(b);
              }
            }
            const storiesAttrCard = getAttributeRanges(attributes, 'stories');
            for (
              let b = storiesAttrCard.minRange;
              b < storiesAttrCard.maxRange + 1;
              b++
            ) {
              const storiesCard = availableStories.find((e) => e === b);
              if (typeof storiesCard === 'undefined') {
                availableStories.push(b);
              }
            }
            const homeTypesCard =
              (crqmis[q].homeType &&
                crqmis[q].homeType.replace(/\s/g, '').split(',')) ||
              [];
            for (let j = 0; j < homeTypesCard.length; j++) {
              const homeTypec = availableHomeTypes.find(
                (e) => e.replace(/\s/g, '') === homeTypesCard[j],
              );
              if (typeof homeTypec === 'undefined') {
                availableHomeTypes.push(homeTypesCard[j]);
              }
            }
          }
        }
      }
    }

    let showAllHomeTypes = true;
    if (bedroomsFilter.length > 0) showAllHomeTypes = false;
    if (bathroomsFilter.length > 0) showAllHomeTypes = false;
    if (storiesFilter.length > 0) showAllHomeTypes = false;
    if (garagesFilter.length > 0) showAllHomeTypes = false;
    if (citiesFilter && citiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (amenitiesFilter && amenitiesFilter.length > 0) showAllHomeTypes = false;
    if (communityStylesFilter && communityStylesFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (lotSizeFilter && lotSizeFilter.length > 0) showAllHomeTypes = false;
    if (productLineFilter && productLineFilter.length > 0) {
      showAllHomeTypes = false;
    }
    if (sizeFilter && sizeFilter.length > 0) showAllHomeTypes = false;
    if (
      priceFilter &&
      ((priceFilter.min && priceFilter.min > 0) ||
        (priceFilter.max && priceFilter.max > 0))
    ) {
      showAllHomeTypes = false;
    }

    const homeTypesList = getFieldValue(fields, 'homeTypesList') || [];
    const availableCompleteHomeTypes = [];
    homeTypesList.forEach((ht) => {
      if (typeof ht !== 'undefined' && ht.length > 0) {
        availableCompleteHomeTypes.push(ht.replace(/\s/g, ''));
      }
    });

    setAvailableOptions({
      price: { minPrice: minPrice, maxPrice: maxPrice }, //
      bedsAndBaths: {
        beds: availableBeds,
        baths: availableBaths,
      }, //
      stories: availableStories, //
      garages: availableGarages, //
      homeTypes: showAllHomeTypes
        ? availableCompleteHomeTypes
        : availableHomeTypes, //
      cities: availableCities, //
      amenities: availableAmenities, //
      communityStyles: availableCommunityStyles, //
      sizes: availableOptions.sizes, //
      sizes:
        lotSizeFilter && lotSizeFilter.length > 0
          ? availableOptions.sizes
          : availableSizes, //
      productLines: availableProductLines, //
      isRVAvailable: isRVSelected
        ? availableOptions.isRVAvailable
        : availableRV,
    });
  }, [isRVSelected]);

  useEffect(() => {
    if (selectedMetro) {
      if (productType === searchProductTypes.COMMUNITY) {
        let metroCommunityDefaultSort = '';
        const isState =
          selectedMetro &&
          selectedMetro[0] &&
          selectedMetro[0].name.toLowerCase() ===
            selectedMetro[0].state.toLowerCase();
        if (selectedMetro && selectedMetro.length > 0) {
          if (isState) {
            metroCommunityDefaultSort =
              (selectedMetro[0] &&
                selectedMetro[0].cities[0] &&
                selectedMetro[0].cities[0].stateCommunityDefaultSort) ||
              '';
          } else {
            metroCommunityDefaultSort =
              (selectedMetro[0] &&
                selectedMetro[0].metroCommunityDefaultSort) ||
              '';
            setMetroCommunityIDsCustomSort(
              selectedMetro[0].metroCommunityIDsCustomSort,
            );
          }
        } else
          metroCommunityDefaultSort =
            selectedMetro.metroCommunityDefaultSort || '';
        //console.log({ selectedMetro, metroCommunityDefaultSort });

        const defaultSort =
          metroCommunityDefaultSort === 'Alphabetical'
            ? 'title'
            : metroCommunityDefaultSort === 'Price'
            ? 'price'
            : metroCommunityDefaultSort === 'Custom'
            ? 'custom'
            : 'availability';
        setSort(defaultSort);
        if (defaultSort === 'custom') setHasCustomSortFeatured(true);
        else setHasCustomSortFeatured(false);
      } else if (productType === searchProductTypes.QMI) {
        //console.log({ selectedMetro });
        let metroQMIDefaultSort = '';
        const isState =
          selectedMetro &&
          selectedMetro[0] &&
          selectedMetro[0].name.toLowerCase() ===
            selectedMetro[0].state.toLowerCase();
        if (selectedMetro && selectedMetro.length > 0) {
          if (isState) {
            metroQMIDefaultSort =
              (selectedMetro[0] &&
                selectedMetro[0].cities[0] &&
                selectedMetro[0].cities[0].stateQMIDefaultSort) ||
              '';
          } else {
            metroQMIDefaultSort =
              (selectedMetro[0] && selectedMetro[0].metroQMIDefaultSort) || '';
          }
        } else metroQMIDefaultSort = selectedMetro.metroQMIDefaultSort || '';

        const defaultSort =
          metroQMIDefaultSort === 'Alphabetical'
            ? 'title'
            : metroQMIDefaultSort === 'Price'
            ? 'price'
            : 'date';
        setSort(defaultSort);
      } else setSort('price');
    }
    // clearFilters();
  }, [selectedMetro]);

  useEffect(() => {
    if (selectedMetro && statesCustomSort) {
      const isState =
        selectedMetro &&
        selectedMetro[0] &&
        selectedMetro[0].name.toLowerCase() ===
          selectedMetro[0].state.toLowerCase();
      if (isState && statesCustomSort && statesCustomSort.length > 0) {
        const stateCommunitiesIdList = statesCustomSort.find(
          (e) => e.state.toLowerCase() === selectedState.toLowerCase(),
        );
        setMetroCommunityIDsCustomSort(
          stateCommunitiesIdList.stateCommunityIDsCustomSort || [],
        );
      }
    }
  }, [selectedMetro, statesCustomSort]);

  useEffect(() => {
    if (productType === searchProductTypes.QMI) {
      if (selectedCommunity && selectedCommunity.length > 1) {
        //console.log({ selectedMetro });
        let lastCommunitySelectedIndex = selectedCommunity.length - 1;

        for (let i = selectedCommunity.length - 1; i > 0; i--) {
          if (selectedCommunity[i].type === 'Community') {
            lastCommunitySelectedIndex = i;
            break;
          }
        }

        const lastCommunitySelected =
          selectedCommunity[lastCommunitySelectedIndex];
        const communityQMIDefaultSort =
          lastCommunitySelected.community_QMIDefaultSort;

        const newQMISort =
          communityQMIDefaultSort === 'Alphabetical'
            ? 'title'
            : communityQMIDefaultSort === 'Price'
            ? 'price'
            : 'date';
        setSort(newQMISort);
      } else {
        let metroQMIDefaultSort = '';
        const isState =
          selectedMetro &&
          selectedMetro[0] &&
          selectedMetro[0].name.toLowerCase() ===
            selectedMetro[0].state.toLowerCase();
        if (selectedMetro && selectedMetro.length > 0) {
          if (isState) {
            metroQMIDefaultSort =
              (selectedMetro[0] &&
                selectedMetro[0].cities[0] &&
                selectedMetro[0].cities[0].stateQMIDefaultSort) ||
              '';
          } else {
            metroQMIDefaultSort =
              (selectedMetro[0] && selectedMetro[0].metroQMIDefaultSort) || '';
          }
        } else
          metroQMIDefaultSort =
            (selectedMetro && selectedMetro.metroQMIDefaultSort) || '';

        const defaultSort =
          metroQMIDefaultSort === 'Alphabetical'
            ? 'title'
            : metroQMIDefaultSort === 'Price'
            ? 'price'
            : 'date';
        setSort(defaultSort);
      }
    }
  }, [selectedCommunity]);

  const isState =
    selectedMetro &&
    selectedMetro[0] &&
    selectedMetro[0].name.toLowerCase() ===
      selectedMetro[0].state.toLowerCase();

  const nQMI =
    isMobile && useMapViewportFilter
      ? communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (visibleInMapIds.includes(c.idCommunity)) {
            acc += (c.qmi || []).length;
          }
          return acc;
        }, 0)
      : !isMobile && (showMap || useDesktopHiddenMapAreaPins)
      ? effectiveVisibleInMapIds &&
        effectiveVisibleInMapIds.length > 0 &&
        communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (effectiveVisibleInMapIds.includes(c.idCommunity)) {
            acc += (c.qmi || []).length;
          }
          return acc;
        }, 0)
      : communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (isState) {
            acc += (c.qmi || []).length;
          } else {
            const metro =
              selectedMetro &&
              selectedMetro[0] &&
              selectedMetro[0].name.toLowerCase();
            if (c.metro.toLowerCase() === metro) acc += (c.qmi || []).length;
          }
          // acc += (c.qmi || []).length;
          return acc;
        }, 0);
  const nPlan =
    isMobile && useMapViewportFilter
      ? communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (visibleInMapIds.includes(c.idCommunity)) {
            acc += (c.plans || []).length;
          }
          return acc;
        }, 0)
      : !isMobile && (showMap || useDesktopHiddenMapAreaPins)
      ? effectiveVisibleInMapIds &&
        effectiveVisibleInMapIds.length > 0 &&
        communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (effectiveVisibleInMapIds.includes(c.idCommunity)) {
            acc += (c.plans || []).length;
          }
          return acc;
        }, 0)
      : communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (isState) {
            acc += (c.plans || []).length;
          } else {
            const metro =
              selectedMetro &&
              selectedMetro[0] &&
              selectedMetro[0].name.toLowerCase();
            if (c.metro.toLowerCase() === metro) acc += (c.plans || []).length;
          }
          return acc;
        }, 0);
  const nCommunity =
    isMobile && useMapViewportFilter
      ? communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (visibleInMapIds.includes(c.idCommunity)) acc += 1;
          return acc;
        }, 0)
      : !isMobile && (showMap || useDesktopHiddenMapAreaPins)
      ? effectiveVisibleInMapIds &&
        effectiveVisibleInMapIds.length > 0 &&
        communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (effectiveVisibleInMapIds.includes(c.idCommunity)) acc += 1;
          return acc;
        }, 0)
      : communitiesMap &&
        communitiesMap.reduce((acc, c) => {
          if (c.idCommunity) acc += 1;
          return acc;
        }, 0);
  // console.log(nCommunity, communitiesMap);
  const searchCardsContainerRef = useRef();
  useEffect(() => {
    if (!showMap && !isMobile) {
      if (searchCardsContainerRef && searchCardsContainerRef.current) {
        setTimeout(() => {
          const current = searchCardsContainerRef.current;
          current.style.marginRight = '1rem';
        }, 1000);
      }
    }
    // isMobile only resolves after mount (SSR renders the 'xs' breakpoint),
    // so it must be a dependency here or desktop keeps the mobile behaviour.
  }, [searchCardsContainerRef, productType, isMobile]);

  /* useEffect(() => {
    console.log({ showMap, hideMap, temporalShowMapMobile });
    if (temporalShowMapMobile) {
      setTimeout(() => {
        //setShowMap(false);
        //setHideMap(true);
        //handleToggleMap();
        setTemporalShowMapMobile(false);
        console.log({ showMap, hideMap, selectedMetro });
        //handleMetroChange(selectedMetro);
      }, 2000);
    }
  }, [temporalShowMapMobile]);*/
  const handleChangeTemporalShowMapMobile = (fl) => {
    // console.log("handleChangeTemporalShowMapMobile");
    if (isMobile) {
      setTimeout(() => {
        // setShowMap(false);
        // setHideMap(true);
        // handleToggleMap();
        setTemporalShowMapMobile(fl);
        // console.log({ showMap, hideMap });
        // handleMetroChange(selectedMetro);
      }, 1500);
    } else setTemporalShowMapMobile(fl);
  };
  /* console.log({
    nCommunity,
    nPlan,
    nQMI,
    productType,
    communitiesMap,
    visibleInMapIds,
    originCommunitiesCards,
    showMap,
    cardsResult,
  });*/
  // console.log("selectedMetro", selectedMetro && selectedMetro[0] && selectedMetro[0].name)
  //console.log({ selectedCommunity });

  const { mouseflowTrackingURL } = useMouseflowTracking();
  useEffect(() => {
    if (mouseflowTrackingURL) {
      if (typeof window !== 'undefined' && window._mfq) {
        window._mfq.push(['tag', 'Search Page']);
      }
    }
  }, [mouseflowTrackingURL]);
  useEffect(() => {
    if (mouseflowTrackingURL) {
      if (atlasRTXSearchValues) {
        if (typeof window !== 'undefined' && window._mfq) {
          const isStateSelected =
            selectedMetro[0].name.toLowerCase() ===
            selectedMetro[0].state.toLowerCase();
          const atlasRTXValues = isStateSelected
            ? { areaName: selectedMetro[0].state, divisionCode: '' }
            : atlasRTXSearchValues.find(
                (e) =>
                  e.areaName.toLowerCase() ===
                  selectedMetro[0].name.toLowerCase(),
              );
          if (atlasRTXValues.divisionCode)
            window._mfq.push(['tag', atlasRTXValues.divisionCode]);
          if (atlasRTXValues.areaName)
            window._mfq.push(['tag', atlasRTXValues.areaName]);
          if (productType === searchProductTypes.COMMUNITY)
            window._mfq.push(['tag', 'Community Tab']);
          if (productType === searchProductTypes.QMI)
            window._mfq.push(['tag', 'QMI Tab']);
          if (productType === searchProductTypes.PLAN)
            window._mfq.push(['tag', 'Plan Tab']);
        }
      }
    }
  }, [mouseflowTrackingURL, atlasRTXSearchValues, selectedMetro, productType]);

  const [hideMarketPromoComponent, setHideMarketPromoComponent] =
    useState(false);
  useEffect(() => {
    if (selectedCommunity.length > 1) {
      const searchHideFlag = selectedCommunity.find(
        (e) => e.hideMarketPromoComponent,
      );
      if (searchHideFlag) setHideMarketPromoComponent(true);
      else setHideMarketPromoComponent(false);
    } else setHideMarketPromoComponent(false);
  }, [selectedCommunity]);

  return (
    <>
      <Helmet>
        <title>{`Find Your Dream Home ${
          (selectedMetro && selectedMetro[0] && selectedMetro[0].name
            ? 'in ' + selectedMetro[0].name
            : '') || ''
        } | Mattamy Homes`}</title>
      </Helmet>
      <SearchSection
        promoBannerActive={
          promoBannerFields &&
          promoBannerFields.displayBanner &&
          promoBannerFields.line2
        }
        measure={nationalNotificationHeight}
        id='MetroSearch'
        role='search'
        tabIndex={0}
        aria-label='Welcome to the search page. Use the filters to narrow down search results. Filtered results will appear upon selection.'
      >
        <div
          className={cx(' w-full h-auto', {
            'z-50': isMobile,
            'z-30': !isMobile,
            fixed: showMap && isMobile,
            relative: !(showMap && isMobile),
          })}
          //isMobile={isMobile}
        >
          <div className='w-full'>
            {isMobile && cardsResult ? (
              <MobileFilters
                selectedMetro={
                  selectedMetro && selectedMetro[0] ? selectedMetro : []
                }
                country={country}
                metros={metros}
                communityCards={originCommunitiesCards}
                listOfAreaMapPins={
                  useMapViewportFilter
                    ? visibleInMapIds
                    : originCommunitiesCards.map((item) => item.id)
                }
                onPrimaryFilterChange={handlePrimaryFilterChange}
                selectedProductType={productType}
                onMetroChange={handleMetroChange}
                onCommunityChange={handleCommunityChange}
                selectedCommunity={selectedCommunity}
                nPlan={nPlan}
                nQMI={nQMI}
                nCommunity={nCommunity}
                clearFilters={() => {
                  if (!isMobile) setMinimumZoom(0);
                  clearFilters();
                }}
                moreFilters={moreFilters}
                setMoreFilters={setMoreFilters}
                priceRangeMin={priceRangeMin}
                priceRangeMax={priceRangeMax}
                priceFilter={priceFilter}
                bedroomsFilter={bedroomsFilter}
                bathroomsFilter={bathroomsFilter}
                productType={productType}
                handleFilterChange={handleFilterChange}
                handleToggleMap={handleToggleMap}
                showMap={showMap}
                nResults={
                  productType === searchProductTypes.COMMUNITY
                    ? nCommunity
                    : cardsResult.length
                }
                onSortChange={handleSortChange}
                sort={sort}
                fields={fields}
                homeTypesList={getFieldValue(fields, 'homeTypesList')}
                onHomeTypeChange={handleHomeTypeChange}
                homeType={homeType}
                citiesFilter={citiesFilter}
                sitecoreFilters={sitecoreFilters}
                onCitiesChange={(values) => {
                  handleFilterChange('cities', values);
                }}
                amenitiesFilter={amenitiesFilter}
                onAmenitiesChange={(values) => {
                  handleFilterChange('amenities', values);
                }}
                lotSizeFilter={lotSizeFilter}
                onLotSizeFilterChange={(val) => {
                  handleFilterChange('lotSize', val);
                }}
                productLineFilter={productLineFilter}
                onProductLineFilterChange={(val) => {
                  handleFilterChange('productLine', val);
                }}
                garagesFilter={garagesFilter}
                onGaragesFilterChange={(val) => {
                  handleFilterChange('garages', val);
                }}
                storiesFilter={storiesFilter}
                onStoriesFilterChange={(val) => {
                  handleFilterChange('stories', val);
                }}
                communityStylesFilter={communityStylesFilter}
                onCommunityStylesChange={(values) => {
                  handleFilterChange('communityStyles', values);
                }}
                clearPriceFilters={clearPriceFilters}
                clearBedroomsFilter={clearBedroomsFilter}
                clearBathroomsFilter={clearBathroomsFilter}
                clearHomeType={clearHomeType}
                availableOptions={availableOptionsWithHomeTypes}
                resultCount={
                  productType === searchProductTypes.COMMUNITY
                    ? nCommunity
                    : cardsResult.length
                }
                communityRef={primaryFilterCommunityRef}
                visibleInMapIds={visibleInMapIds}
                mapBoundsInitialized={useMapViewportFilter}
                onRVSelectedChange={onRVSelectedChange}
                isRVSelected={isRVSelected}
                withMultipleSelection={withMultipleSelection}
                hasCustomSortFeatured={hasCustomSortFeatured}
              />
            ) : (
              <PrimaryFilter
                selectedMetro={
                  selectedMetro && selectedMetro[0] ? selectedMetro : []
                }
                country={country}
                metros={metros}
                communityCards={originCommunitiesCards}
                listOfAreaMapPins={
                  useDesktopHiddenMapAreaPins
                    ? effectiveVisibleInMapIds
                    : showMap
                    ? visibleInMapIds
                    : originCommunitiesCards.map((item) => {
                        const metro =
                          (selectedMetro &&
                            selectedMetro[0] &&
                            selectedMetro[0].name.toLowerCase()) ||
                          '';
                        return isState
                          ? item.id
                          : item.metro.toLowerCase() === metro && item.id;
                      })
                }
                onPrimaryFilterChange={handlePrimaryFilterChange}
                selectedProductType={productType}
                onMetroChange={handleMetroChange}
                onCommunityChange={handleCommunityChange}
                selectedCommunity={selectedCommunity}
                nPlan={nPlan}
                nQMI={nQMI}
                nCommunity={nCommunity}
                clearFilters={() => {
                  if (!isMobile) setMinimumZoom(0);
                  clearFilters();
                }}
                moreFilters={moreFilters}
                setMoreFilters={setMoreFilters}
                resultCount={cardsResult.length}
                communityRef={primaryFilterCommunityRef}
                withMultipleSelection={withMultipleSelection}
              />
            )}
          </div>
        </div>
        <Content
          promoBannerActive={
            promoBannerFields &&
            promoBannerFields.displayBanner &&
            promoBannerFields.line2
          }
          measure={nationalNotificationHeight}
          className='md:relative md:flex md:justify-between'
        >
          {isMobile && (
            <ToogleMapMobile
              className='fixed inset-x-0 bottom-0 flex flex-col items-center justify-center pointer-events-none pb-4'
              isMapOpen={showMap}
            >
              {showMobileCard && showMap && (
                <MapSearchCardMobile
                  card={communitiesMap.find(
                    (c) => c.idCommunity === selectedProduct,
                  )}
                  favoritesList={favoritesList}
                />
              )}
              <ToggleMap
                className={cx(
                  'flex items-center bg-mattamy-blue-light mb-10 p-2 rounded focus:outline-none cursor-pointer',
                )}
                onClick={handleToggleMap}
                isMobile={isMobile}
              >
                <div className='flex items-center justify-center pl-1 ml-2'>
                  <IconContainer
                    className='bg-white rounded-full w-8 h-8 flex justify-center items-center'
                    showMap={showMap}
                  >
                    {showMap ? (
                      <div className='flex flex-col justify-around h-4'>
                        <ListIconBar className='bg-mattamy-blue-light'></ListIconBar>
                        <ListIconBar className='bg-mattamy-blue-light'></ListIconBar>
                        <ListIconBar className='bg-mattamy-blue-light'></ListIconBar>
                      </div>
                    ) : (
                      <MapMarkerIcon className='text-action-blue w-4 h-4' />
                    )}
                  </IconContainer>
                  <span className='m-2 font-graphie text-base text-white'>
                    {showMap ? 'List' : 'Map'}
                  </span>
                </div>
              </ToggleMap>
            </ToogleMapMobile>
          )}
          <SearchResultContainer
            ref={searchResultRef}
            showMap={cardsResult.length !== 0 || isMobile ? showMap : false}
            className='transition-width duration-300'
          >
            {!isMobile && cardsResult.length !== 0 && (
              <SecondaryFilter
                priceRangeMin={priceRangeMin}
                priceRangeMax={priceRangeMax}
                priceFilter={priceFilter}
                bedroomsFilter={bedroomsFilter}
                bathroomsFilter={bathroomsFilter}
                productType={productType}
                handleFilterChange={handleFilterChange}
                handleToggleMap={handleToggleMap}
                showMap={showMap}
                onSortChange={handleSortChange}
                sort={sort}
                homeTypesList={getFieldValue(fields, 'homeTypesList')}
                onHomeTypeChange={handleHomeTypeChange}
                homeType={homeType}
                moreFilters={moreFilters}
                setMoreFilters={setMoreFilters}
                moreFiltersNumber={moreFiltersNumber}
                clearPriceFilters={clearPriceFilters}
                clearHomeType={clearHomeType}
                moreFiltersModalButtonRef={moreFiltersModalButtonRef}
                hasDen={hasDen}
                availableOptions={availableOptionsWithHomeTypes}
                hasCustomSortFeatured={hasCustomSortFeatured}
              />
            )}
            <SearchCardsContainer
              className={cx('flex-grow overflow-y-auto h-full', {
                'md:mr-0': !showMap,
                hidden: showMap && isMobile,
              })}
              ref={searchCardsContainerRef}
              key={showMap}
              data-aos-anchor='header'
              data-aos='fade-in-up'
              data-aos-duration='1000'
              data-aos-delay={!isMobile ? '200' : '0'}
            >
              {(isMobile && temporalShowMapMobile) ||
              (!isMobile && showMap && temporalShowMapMobile) ? (
                <div></div>
              ) : (
                !isLoading && (
                  <SearchResult
                    cards={cardsResult}
                    visibleCommunities={visibleInMapIds}
                    gridColumns={showMap ? 3 : 5}
                    noResults={getFieldValue(fields, 'noResults')}
                    productType={productType}
                    onClearFilters={() => {
                      if (!isMobile) setMinimumZoom(0);
                      clearFilters();
                    }}
                    containerRef={searchResultRef}
                    isMapShow={showMap}
                    searchTitle={productTypeTitle}
                    selectedMetro={selectedMetro && selectedMetro[0]}
                    sort={sort}
                    isMobile={isMobile}
                    isLoading={isLoading}
                    favoritesList={favoritesList}
                    saveFavorite={saveFavorite}
                    deleteFavorite={deleteFavorite}
                    tooltipText={getFieldValue(
                      fields,
                      'toolTipMortgageDisclaimerText',
                    )}
                    quickStartHomesTooltip={getFieldValue(
                      fields,
                      'quickStartHomesTooltip',
                    )}
                    selectedMapPin={selectedProduct}
                    country={country}
                    mortgageAmounts={mortgageAmounts}
                    priceDifferentialText={priceDifferentialText}
                    lastCommunitySelected={
                      selectedCommunity &&
                      selectedCommunity.length > 1 &&
                      selectedCommunity[selectedCommunity.length - 1]
                    }
                    idList={metroCommunityIDsCustomSort}
                    hideMarketPromoComponent={hideMarketPromoComponent}
                  />
                )
              )}
              {(!isMobile || (isMobile && !showMap)) && (
                <Placeholder
                  name='search-footer'
                  rendering={rendering}
                  isMetroSearch={true}
                  showMap={showMap}
                />
              )}
            </SearchCardsContainer>
          </SearchResultContainer>
          <SearchMapContainer
            className={'absolute top-0'}
            hidden={
              isMobile
                ? false
                : Object.keys(cardsResult).length === 0 &&
                  visibleInMapIds.length === 0
            }
            mounted={mapMounted}
            showMap={
              isMobile
                ? temporalShowMapMobile
                  ? true
                  : showMap
                : Object.keys(cardsResult).length > 0 &&
                  visibleInMapIds.length > 0 &&
                  showMap
            }
            isMobile={isMobile}
            style={!isMobile ? mapSlide : {}}
            notificationActive={notificationActive}
            promoBannerActive={
              promoBannerFields &&
              promoBannerFields.displayBanner &&
              promoBannerFields.line2
                ? true
                : false
            }
            measure={nationalNotificationHeight}
          >
            <MapWrapper className='absolute bottom-0 right-0 w-full h-full'>
              {!isLoading &&
                originCommunitiesCards &&
                originCommunitiesCards.length &&
                communitiesMap &&
                communitiesMap.length &&
                (showMap || isMobile) && (
                  <SearchMap
                    items={originCommunitiesCards}
                    itemsSelected={communitiesMap}
                    selectedCommunities={selectedCommunity}
                    temporalShowMapMobile={temporalShowMapMobile}
                    onVisibleItemsChange={handleVisibleItemsChange}
                    visible={
                      isMobile
                        ? true
                        : Object.keys(cardsResult).length > 0 && showMap
                    }
                    selectedMetro={selectedMetro}
                    resetBounds={resetBounds}
                    onResetBoundsChange={handleResetBoundsChange}
                    onSelectItem={handleSelectItem}
                    selectedItem={selectedProduct}
                    maximumZoom={parseFloat(maximumZoom)}
                    minimumZoom={
                      selectedMetro &&
                      selectedMetro.length &&
                      selectedMetro.length > 1
                        ? null
                        : parseFloat(minimumZoom)
                    }
                    metroSelectedCenter={
                      selectedMetro &&
                      selectedMetro.length &&
                      selectedMetro.length > 1
                        ? { latitude: '', longitude: '' }
                        : {
                            latitude:
                              (selectedMetro &&
                                selectedMetro[0] &&
                                selectedMetro[0].latitude) ||
                              '',
                            longitude:
                              (selectedMetro &&
                                selectedMetro[0] &&
                                selectedMetro[0].longitude) ||
                              '',
                          }
                    }
                    favoritesList={favoritesList}
                    handleChangeTemporalShowMapMobile={
                      handleChangeTemporalShowMapMobile
                    }
                  />
                )}
            </MapWrapper>
          </SearchMapContainer>
        </Content>
        {moreFilters && !isMobile && (
          <MoreFiltersModal
            isOpen={moreFilters}
            onClose={() => {
              setMoreFilters(false);
              let current = moreFiltersModalButtonRef.current;
              if (current) current.focus();
            }}
            fields={fields}
            nResults={
              productType === searchProductTypes.COMMUNITY
                ? nCommunity
                : cardsResult.length
            }
            citiesFilter={citiesFilter}
            onCitiesChange={(values) => {
              handleFilterChange('cities', values);
            }}
            amenitiesFilter={amenitiesFilter}
            onAmenitiesChange={(values) => {
              handleFilterChange('amenities', values);
            }}
            lotSizeFilter={lotSizeFilter}
            onLotSizeFilterChange={(val) => {
              handleFilterChange('lotSize', val);
            }}
            productLineFilter={productLineFilter}
            onProductLineFilterChange={(val) => {
              handleFilterChange('productLine', val);
            }}
            storiesFilter={storiesFilter}
            onStoriesFilterChange={(val) => {
              handleFilterChange('stories', val);
            }}
            garagesFilter={garagesFilter}
            onGaragesFilterChange={(val) => {
              handleFilterChange('garages', val);
            }}
            communityStylesFilter={communityStylesFilter}
            onCommunityStylesChange={(values) => {
              handleFilterChange('communityStyles', values);
            }}
            clearMoreFilters={() => {
              if (!isMobile) setMinimumZoom(0);
              clearMoreFilters();
            }}
            country={country}
            sitecoreFilters={sitecoreFilters}
            selectedMetro={selectedMetro}
            availableOptions={availableOptions}
            visibleInMapIds={
              showMap
                ? visibleInMapIds
                : visibleInMapIds.length > 0
                ? visibleInMapIds
                : communitiesMap.map((e) => e.idCommunity)
            }
            onRVSelectedChange={onRVSelectedChange}
            isRVSelected={isRVSelected}
          />
        )}
      </SearchSection>

      <WaitingScreen
        isOpen={isLoading || (isMobile && temporalShowMapMobile)}
      />
      <MetroSearchPromoBanner fields={promoBannerFields} />
    </>
  );
};

export default withRouter(MetroSearch);
